export const elementsAndIsotopes = [
  {
    number: 1,
    isotopes: [
      { nominal: 1, mass: 1.00782503223, abundance: 0.999885 },
      { nominal: 2, mass: 2.01410177812, abundance: 0.000115 },
      { nominal: 3, mass: 3.0160492779 },
      { nominal: 4, mass: 4.02643 },
      { nominal: 5, mass: 5.035311 },
      { nominal: 6, mass: 6.04496 },
      { nominal: 7, mass: 7.0527 },
    ],
    symbol: 'H',
    mass: 1.0079407540557772,
    name: 'Hydrogen',
    monoisotopicMass: 1.00782503223,
  },
  {
    number: 2,
    isotopes: [
      { nominal: 3, mass: 3.0160293201, abundance: 0.00000134 },
      { nominal: 4, mass: 4.00260325413, abundance: 0.99999866 },
      { nominal: 5, mass: 5.012057 },
      { nominal: 6, mass: 6.018885891 },
      { nominal: 7, mass: 7.0279907 },
      { nominal: 8, mass: 8.03393439 },
      { nominal: 9, mass: 9.043946 },
      { nominal: 10, mass: 10.05279 },
    ],
    symbol: 'He',
    mass: 4.002601932120929,
    name: 'Helium',
    monoisotopicMass: 4.00260325413,
  },
  {
    number: 3,
    isotopes: [
      { nominal: 3, mass: 3.0308 },
      { nominal: 4, mass: 4.02719 },
      { nominal: 5, mass: 5.012538 },
      { nominal: 6, mass: 6.0151228874, abundance: 0.0759 },
      { nominal: 7, mass: 7.0160034366, abundance: 0.9241 },
      { nominal: 8, mass: 8.022486246 },
      { nominal: 9, mass: 9.02679019 },
      { nominal: 10, mass: 10.035483 },
      { nominal: 11, mass: 11.04372358 },
      { nominal: 12, mass: 12.052517 },
      { nominal: 13, mass: 13.06263 },
    ],
    symbol: 'Li',
    mass: 6.94003660291572,
    name: 'Lithium',
    monoisotopicMass: 7.0160034366,
  },
  {
    number: 4,
    isotopes: [
      { nominal: 5, mass: 5.0399 },
      { nominal: 6, mass: 6.0197264 },
      { nominal: 7, mass: 7.016928717 },
      { nominal: 8, mass: 8.005305102 },
      { nominal: 9, mass: 9.012183065, abundance: 1 },
      { nominal: 10, mass: 10.013534695 },
      { nominal: 11, mass: 11.02166108 },
      { nominal: 12, mass: 12.0269221 },
      { nominal: 13, mass: 13.036135 },
      { nominal: 14, mass: 14.04289 },
      { nominal: 15, mass: 15.05342 },
      { nominal: 16, mass: 16.06167 },
    ],
    symbol: 'Be',
    mass: 9.012183065,
    name: 'Beryllium',
    monoisotopicMass: 9.012183065,
  },
  {
    number: 5,
    isotopes: [
      { nominal: 6, mass: 6.0508 },
      { nominal: 7, mass: 7.029712 },
      { nominal: 8, mass: 8.0246073 },
      { nominal: 9, mass: 9.01332965 },
      { nominal: 10, mass: 10.01293695, abundance: 0.199 },
      { nominal: 11, mass: 11.00930536, abundance: 0.801 },
      { nominal: 12, mass: 12.0143527 },
      { nominal: 13, mass: 13.0177802 },
      { nominal: 14, mass: 14.025404 },
      { nominal: 15, mass: 15.031088 },
      { nominal: 16, mass: 16.039842 },
      { nominal: 17, mass: 17.04699 },
      { nominal: 18, mass: 18.05566 },
      { nominal: 19, mass: 19.0631 },
      { nominal: 20, mass: 20.07207 },
      { nominal: 21, mass: 21.08129 },
    ],
    symbol: 'B',
    mass: 10.811028046410001,
    name: 'Boron',
    monoisotopicMass: 11.00930536,
  },
  {
    number: 6,
    isotopes: [
      { nominal: 8, mass: 8.037643 },
      { nominal: 9, mass: 9.0310372 },
      { nominal: 10, mass: 10.01685331 },
      { nominal: 11, mass: 11.0114336 },
      { nominal: 12, mass: 12, abundance: 0.9893 },
      { nominal: 13, mass: 13.00335483507, abundance: 0.0107 },
      { nominal: 14, mass: 14.0032419884 },
      { nominal: 15, mass: 15.01059926 },
      { nominal: 16, mass: 16.0147013 },
      { nominal: 17, mass: 17.022577 },
      { nominal: 18, mass: 18.026751 },
      { nominal: 19, mass: 19.0348 },
      { nominal: 20, mass: 20.04032 },
      { nominal: 21, mass: 21.049 },
      { nominal: 22, mass: 22.05753 },
      { nominal: 23, mass: 23.0689 },
    ],
    symbol: 'C',
    mass: 12.010735896735248,
    name: 'Carbon',
    monoisotopicMass: 12,
  },
  {
    number: 7,
    isotopes: [
      { nominal: 10, mass: 10.04165 },
      { nominal: 11, mass: 11.026091 },
      { nominal: 12, mass: 12.0186132 },
      { nominal: 13, mass: 13.00573861 },
      { nominal: 14, mass: 14.00307400443, abundance: 0.99636 },
      { nominal: 15, mass: 15.00010889888, abundance: 0.00364 },
      { nominal: 16, mass: 16.0061019 },
      { nominal: 17, mass: 17.008449 },
      { nominal: 18, mass: 18.014078 },
      { nominal: 19, mass: 19.017022 },
      { nominal: 20, mass: 20.023366 },
      { nominal: 21, mass: 21.02711 },
      { nominal: 22, mass: 22.03439 },
      { nominal: 23, mass: 23.04114 },
      { nominal: 24, mass: 24.05039 },
      { nominal: 25, mass: 25.0601 },
    ],
    symbol: 'N',
    mass: 14.006703211445798,
    name: 'Nitrogen',
    monoisotopicMass: 14.00307400443,
  },
  {
    number: 8,
    isotopes: [
      { nominal: 12, mass: 12.034262 },
      { nominal: 13, mass: 13.024815 },
      { nominal: 14, mass: 14.00859636 },
      { nominal: 15, mass: 15.00306562 },
      { nominal: 16, mass: 15.99491461957, abundance: 0.99757 },
      { nominal: 17, mass: 16.9991317565, abundance: 0.00038 },
      { nominal: 18, mass: 17.99915961286, abundance: 0.00205 },
      { nominal: 19, mass: 19.003578 },
      { nominal: 20, mass: 20.00407535 },
      { nominal: 21, mass: 21.008655 },
      { nominal: 22, mass: 22.009966 },
      { nominal: 23, mass: 23.015696 },
      { nominal: 24, mass: 24.01986 },
      { nominal: 25, mass: 25.02936 },
      { nominal: 26, mass: 26.03729 },
      { nominal: 27, mass: 27.04772 },
      { nominal: 28, mass: 28.05591 },
    ],
    symbol: 'O',
    mass: 15.999404924318277,
    name: 'Oxygen',
    monoisotopicMass: 15.99491461957,
  },
  {
    number: 9,
    isotopes: [
      { nominal: 14, mass: 14.034315 },
      { nominal: 15, mass: 15.018043 },
      { nominal: 16, mass: 16.0114657 },
      { nominal: 17, mass: 17.00209524 },
      { nominal: 18, mass: 18.00093733 },
      { nominal: 19, mass: 18.99840316273, abundance: 1 },
      { nominal: 20, mass: 19.999981252 },
      { nominal: 21, mass: 20.9999489 },
      { nominal: 22, mass: 22.002999 },
      { nominal: 23, mass: 23.003557 },
      { nominal: 24, mass: 24.008115 },
      { nominal: 25, mass: 25.012199 },
      { nominal: 26, mass: 26.020038 },
      { nominal: 27, mass: 27.02644 },
      { nominal: 28, mass: 28.03534 },
      { nominal: 29, mass: 29.04254 },
      { nominal: 30, mass: 30.05165 },
      { nominal: 31, mass: 31.05971 },
    ],
    symbol: 'F',
    mass: 18.99840316273,
    name: 'Fluorine',
    monoisotopicMass: 18.99840316273,
  },
  {
    number: 10,
    isotopes: [
      { nominal: 16, mass: 16.02575 },
      { nominal: 17, mass: 17.01771396 },
      { nominal: 18, mass: 18.0057087 },
      { nominal: 19, mass: 19.00188091 },
      { nominal: 20, mass: 19.9924401762, abundance: 0.9048 },
      { nominal: 21, mass: 20.993846685, abundance: 0.0027 },
      { nominal: 22, mass: 21.991385114, abundance: 0.0925 },
      { nominal: 23, mass: 22.99446691 },
      { nominal: 24, mass: 23.99361065 },
      { nominal: 25, mass: 24.997789 },
      { nominal: 26, mass: 26.000515 },
      { nominal: 27, mass: 27.007553 },
      { nominal: 28, mass: 28.01212 },
      { nominal: 29, mass: 29.01975 },
      { nominal: 30, mass: 30.02473 },
      { nominal: 31, mass: 31.0331 },
      { nominal: 32, mass: 32.03972 },
      { nominal: 33, mass: 33.04938 },
      { nominal: 34, mass: 34.05673 },
    ],
    symbol: 'Ne',
    mass: 20.18004638052026,
    name: 'Neon',
    monoisotopicMass: 19.9924401762,
  },
  {
    number: 11,
    isotopes: [
      { nominal: 18, mass: 18.02688 },
      { nominal: 19, mass: 19.01388 },
      { nominal: 20, mass: 20.0073544 },
      { nominal: 21, mass: 20.99765469 },
      { nominal: 22, mass: 21.99443741 },
      { nominal: 23, mass: 22.989769282, abundance: 1 },
      { nominal: 24, mass: 23.99096295 },
      { nominal: 25, mass: 24.989954 },
      { nominal: 26, mass: 25.9926346 },
      { nominal: 27, mass: 26.9940765 },
      { nominal: 28, mass: 27.998939 },
      { nominal: 29, mass: 29.0028771 },
      { nominal: 30, mass: 30.0090979 },
      { nominal: 31, mass: 31.013163 },
      { nominal: 32, mass: 32.02019 },
      { nominal: 33, mass: 33.02573 },
      { nominal: 34, mass: 34.03359 },
      { nominal: 35, mass: 35.04062 },
      { nominal: 36, mass: 36.04929 },
      { nominal: 37, mass: 37.05705 },
    ],
    symbol: 'Na',
    mass: 22.989769282,
    name: 'Sodium',
    monoisotopicMass: 22.989769282,
  },
  {
    number: 12,
    isotopes: [
      { nominal: 19, mass: 19.034169 },
      { nominal: 20, mass: 20.01885 },
      { nominal: 21, mass: 21.011716 },
      { nominal: 22, mass: 21.99957065 },
      { nominal: 23, mass: 22.99412421 },
      { nominal: 24, mass: 23.985041697, abundance: 0.7899 },
      { nominal: 25, mass: 24.985836976, abundance: 0.1 },
      { nominal: 26, mass: 25.982592968, abundance: 0.1101 },
      { nominal: 27, mass: 26.984340624 },
      { nominal: 28, mass: 27.9838767 },
      { nominal: 29, mass: 28.988617 },
      { nominal: 30, mass: 29.9904629 },
      { nominal: 31, mass: 30.996648 },
      { nominal: 32, mass: 31.9991102 },
      { nominal: 33, mass: 33.0053271 },
      { nominal: 34, mass: 34.008935 },
      { nominal: 35, mass: 35.01679 },
      { nominal: 36, mass: 36.02188 },
      { nominal: 37, mass: 37.03037 },
      { nominal: 38, mass: 38.03658 },
      { nominal: 39, mass: 39.04538 },
      { nominal: 40, mass: 40.05218 },
    ],
    symbol: 'Mg',
    mass: 24.3050516198371,
    name: 'Magnesium',
    monoisotopicMass: 23.985041697,
  },
  {
    number: 13,
    isotopes: [
      { nominal: 21, mass: 21.02897 },
      { nominal: 22, mass: 22.01954 },
      { nominal: 23, mass: 23.00724435 },
      { nominal: 24, mass: 23.9999489 },
      { nominal: 25, mass: 24.9904281 },
      { nominal: 26, mass: 25.986891904 },
      { nominal: 27, mass: 26.98153853, abundance: 1 },
      { nominal: 28, mass: 27.98191021 },
      { nominal: 29, mass: 28.9804565 },
      { nominal: 30, mass: 29.98296 },
      { nominal: 31, mass: 30.983945 },
      { nominal: 32, mass: 31.988085 },
      { nominal: 33, mass: 32.990909 },
      { nominal: 34, mass: 33.996705 },
      { nominal: 35, mass: 34.999764 },
      { nominal: 36, mass: 36.00639 },
      { nominal: 37, mass: 37.01053 },
      { nominal: 38, mass: 38.0174 },
      { nominal: 39, mass: 39.02254 },
      { nominal: 40, mass: 40.03003 },
      { nominal: 41, mass: 41.03638 },
      { nominal: 42, mass: 42.04384 },
      { nominal: 43, mass: 43.05147 },
    ],
    symbol: 'Al',
    mass: 26.98153853,
    name: 'Aluminium',
    monoisotopicMass: 26.98153853,
  },
  {
    number: 14,
    isotopes: [
      { nominal: 22, mass: 22.03579 },
      { nominal: 23, mass: 23.02544 },
      { nominal: 24, mass: 24.011535 },
      { nominal: 25, mass: 25.004109 },
      { nominal: 26, mass: 25.99233384 },
      { nominal: 27, mass: 26.98670481 },
      { nominal: 28, mass: 27.97692653465, abundance: 0.92223 },
      { nominal: 29, mass: 28.9764946649, abundance: 0.04685 },
      { nominal: 30, mass: 29.973770136, abundance: 0.03092 },
      { nominal: 31, mass: 30.975363194 },
      { nominal: 32, mass: 31.97415154 },
      { nominal: 33, mass: 32.97797696 },
      { nominal: 34, mass: 33.978576 },
      { nominal: 35, mass: 34.984583 },
      { nominal: 36, mass: 35.986695 },
      { nominal: 37, mass: 36.992921 },
      { nominal: 38, mass: 37.995523 },
      { nominal: 39, mass: 39.002491 },
      { nominal: 40, mass: 40.00583 },
      { nominal: 41, mass: 41.01301 },
      { nominal: 42, mass: 42.01778 },
      { nominal: 43, mass: 43.0248 },
      { nominal: 44, mass: 44.03061 },
      { nominal: 45, mass: 45.03995 },
    ],
    symbol: 'Si',
    mass: 28.085498705705955,
    name: 'Silicon',
    monoisotopicMass: 27.97692653465,
  },
  {
    number: 15,
    isotopes: [
      { nominal: 24, mass: 24.03577 },
      { nominal: 25, mass: 25.02119 },
      { nominal: 26, mass: 26.01178 },
      { nominal: 27, mass: 26.999224 },
      { nominal: 28, mass: 27.9923266 },
      { nominal: 29, mass: 28.98180079 },
      { nominal: 30, mass: 29.97831375 },
      { nominal: 31, mass: 30.97376199842, abundance: 1 },
      { nominal: 32, mass: 31.973907643 },
      { nominal: 33, mass: 32.9717257 },
      { nominal: 34, mass: 33.97364589 },
      { nominal: 35, mass: 34.9733141 },
      { nominal: 36, mass: 35.97826 },
      { nominal: 37, mass: 36.979607 },
      { nominal: 38, mass: 37.984252 },
      { nominal: 39, mass: 38.986227 },
      { nominal: 40, mass: 39.99133 },
      { nominal: 41, mass: 40.994654 },
      { nominal: 42, mass: 42.00108 },
      { nominal: 43, mass: 43.00502 },
      { nominal: 44, mass: 44.01121 },
      { nominal: 45, mass: 45.01645 },
      { nominal: 46, mass: 46.02446 },
      { nominal: 47, mass: 47.03139 },
    ],
    symbol: 'P',
    mass: 30.97376199842,
    name: 'Phosphorus',
    monoisotopicMass: 30.97376199842,
  },
  {
    number: 16,
    isotopes: [
      { nominal: 26, mass: 26.02907 },
      { nominal: 27, mass: 27.01828 },
      { nominal: 28, mass: 28.00437 },
      { nominal: 29, mass: 28.996611 },
      { nominal: 30, mass: 29.98490703 },
      { nominal: 31, mass: 30.97955701 },
      { nominal: 32, mass: 31.9720711744, abundance: 0.9499 },
      { nominal: 33, mass: 32.9714589098, abundance: 0.0075 },
      { nominal: 34, mass: 33.967867004, abundance: 0.0425 },
      { nominal: 35, mass: 34.96903231 },
      { nominal: 36, mass: 35.96708071, abundance: 0.0001 },
      { nominal: 37, mass: 36.97112551 },
      { nominal: 38, mass: 37.9711633 },
      { nominal: 39, mass: 38.975134 },
      { nominal: 40, mass: 39.9754826 },
      { nominal: 41, mass: 40.9795935 },
      { nominal: 42, mass: 41.9810651 },
      { nominal: 43, mass: 42.9869076 },
      { nominal: 44, mass: 43.9901188 },
      { nominal: 45, mass: 44.99572 },
      { nominal: 46, mass: 46.00004 },
      { nominal: 47, mass: 47.00795 },
      { nominal: 48, mass: 48.0137 },
      { nominal: 49, mass: 49.02276 },
    ],
    symbol: 'S',
    mass: 32.06478740612706,
    name: 'Sulfur',
    monoisotopicMass: 31.9720711744,
  },
  {
    number: 17,
    isotopes: [
      { nominal: 28, mass: 28.02954 },
      { nominal: 29, mass: 29.01478 },
      { nominal: 30, mass: 30.00477 },
      { nominal: 31, mass: 30.992414 },
      { nominal: 32, mass: 31.98568464 },
      { nominal: 33, mass: 32.97745199 },
      { nominal: 34, mass: 33.973762485 },
      { nominal: 35, mass: 34.968852682, abundance: 0.7576 },
      { nominal: 36, mass: 35.968306809 },
      { nominal: 37, mass: 36.965902602, abundance: 0.2424 },
      { nominal: 38, mass: 37.96801044 },
      { nominal: 39, mass: 38.9680082 },
      { nominal: 40, mass: 39.970415 },
      { nominal: 41, mass: 40.970685 },
      { nominal: 42, mass: 41.97325 },
      { nominal: 43, mass: 42.97389 },
      { nominal: 44, mass: 43.97787 },
      { nominal: 45, mass: 44.98029 },
      { nominal: 46, mass: 45.98517 },
      { nominal: 47, mass: 46.98916 },
      { nominal: 48, mass: 47.99564 },
      { nominal: 49, mass: 49.00123 },
      { nominal: 50, mass: 50.00905 },
      { nominal: 51, mass: 51.01554 },
    ],
    symbol: 'Cl',
    mass: 35.452937582608,
    name: 'Chlorine',
    monoisotopicMass: 34.968852682,
  },
  {
    number: 18,
    isotopes: [
      { nominal: 30, mass: 30.02307 },
      { nominal: 31, mass: 31.01212 },
      { nominal: 32, mass: 31.9976378 },
      { nominal: 33, mass: 32.98992555 },
      { nominal: 34, mass: 33.98027009 },
      { nominal: 35, mass: 34.97525759 },
      { nominal: 36, mass: 35.967545105, abundance: 0.003336 },
      { nominal: 37, mass: 36.96677633 },
      { nominal: 38, mass: 37.96273211, abundance: 0.000629 },
      { nominal: 39, mass: 38.964313 },
      { nominal: 40, mass: 39.9623831237, abundance: 0.996035 },
      { nominal: 41, mass: 40.96450057 },
      { nominal: 42, mass: 41.9630457 },
      { nominal: 43, mass: 42.9656361 },
      { nominal: 44, mass: 43.9649238 },
      { nominal: 45, mass: 44.96803973 },
      { nominal: 46, mass: 45.968083 },
      { nominal: 47, mass: 46.972935 },
      { nominal: 48, mass: 47.97591 },
      { nominal: 49, mass: 48.9819 },
      { nominal: 50, mass: 49.98613 },
      { nominal: 51, mass: 50.9937 },
      { nominal: 52, mass: 51.99896 },
      { nominal: 53, mass: 53.00729 },
    ],
    symbol: 'Ar',
    mass: 39.947798563582005,
    name: 'Argon',
    monoisotopicMass: 39.9623831237,
  },
  {
    number: 19,
    isotopes: [
      { nominal: 32, mass: 32.02265 },
      { nominal: 33, mass: 33.00756 },
      { nominal: 34, mass: 33.99869 },
      { nominal: 35, mass: 34.98800541 },
      { nominal: 36, mass: 35.98130201 },
      { nominal: 37, mass: 36.97337589 },
      { nominal: 38, mass: 37.96908112 },
      { nominal: 39, mass: 38.9637064864, abundance: 0.932581 },
      { nominal: 40, mass: 39.963998166, abundance: 0.000117 },
      { nominal: 41, mass: 40.9618252579, abundance: 0.067302 },
      { nominal: 42, mass: 41.96240231 },
      { nominal: 43, mass: 42.9607347 },
      { nominal: 44, mass: 43.96158699 },
      { nominal: 45, mass: 44.96069149 },
      { nominal: 46, mass: 45.96198159 },
      { nominal: 47, mass: 46.9616616 },
      { nominal: 48, mass: 47.96534119 },
      { nominal: 49, mass: 48.96821075 },
      { nominal: 50, mass: 49.97238 },
      { nominal: 51, mass: 50.975828 },
      { nominal: 52, mass: 51.98224 },
      { nominal: 53, mass: 52.98746 },
      { nominal: 54, mass: 53.99463 },
      { nominal: 55, mass: 55.00076 },
      { nominal: 56, mass: 56.00851 },
    ],
    symbol: 'K',
    mass: 39.098300910086,
    name: 'Potassium',
    monoisotopicMass: 38.9637064864,
  },
  {
    number: 20,
    isotopes: [
      { nominal: 34, mass: 34.01487 },
      { nominal: 35, mass: 35.00514 },
      { nominal: 36, mass: 35.993074 },
      { nominal: 37, mass: 36.98589785 },
      { nominal: 38, mass: 37.97631922 },
      { nominal: 39, mass: 38.97071081 },
      { nominal: 40, mass: 39.962590863, abundance: 0.96941 },
      { nominal: 41, mass: 40.96227792 },
      { nominal: 42, mass: 41.95861783, abundance: 0.00647 },
      { nominal: 43, mass: 42.95876644, abundance: 0.00135 },
      { nominal: 44, mass: 43.95548156, abundance: 0.02086 },
      { nominal: 45, mass: 44.95618635 },
      { nominal: 46, mass: 45.953689, abundance: 0.00004 },
      { nominal: 47, mass: 46.9545424 },
      { nominal: 48, mass: 47.95252276, abundance: 0.00187 },
      { nominal: 49, mass: 48.95566274 },
      { nominal: 50, mass: 49.9574992 },
      { nominal: 51, mass: 50.960989 },
      { nominal: 52, mass: 51.963217 },
      { nominal: 53, mass: 52.96945 },
      { nominal: 54, mass: 53.9734 },
      { nominal: 55, mass: 54.9803 },
      { nominal: 56, mass: 55.98508 },
      { nominal: 57, mass: 56.99262 },
      { nominal: 58, mass: 57.99794 },
    ],
    symbol: 'Ca',
    mass: 40.078022511017735,
    name: 'Calcium',
    monoisotopicMass: 39.962590863,
  },
  {
    number: 21,
    isotopes: [
      { nominal: 36, mass: 36.01648 },
      { nominal: 37, mass: 37.00374 },
      { nominal: 38, mass: 37.99512 },
      { nominal: 39, mass: 38.984785 },
      { nominal: 40, mass: 39.9779673 },
      { nominal: 41, mass: 40.969251105 },
      { nominal: 42, mass: 41.96551653 },
      { nominal: 43, mass: 42.9611505 },
      { nominal: 44, mass: 43.9594029 },
      { nominal: 45, mass: 44.95590828, abundance: 1 },
      { nominal: 46, mass: 45.95516826 },
      { nominal: 47, mass: 46.9524037 },
      { nominal: 48, mass: 47.9522236 },
      { nominal: 49, mass: 48.9500146 },
      { nominal: 50, mass: 49.952176 },
      { nominal: 51, mass: 50.953592 },
      { nominal: 52, mass: 51.95688 },
      { nominal: 53, mass: 52.95909 },
      { nominal: 54, mass: 53.96393 },
      { nominal: 55, mass: 54.96782 },
      { nominal: 56, mass: 55.97345 },
      { nominal: 57, mass: 56.97777 },
      { nominal: 58, mass: 57.98403 },
      { nominal: 59, mass: 58.98894 },
      { nominal: 60, mass: 59.99565 },
      { nominal: 61, mass: 61.001 },
    ],
    symbol: 'Sc',
    mass: 44.95590828,
    name: 'Scandium',
    monoisotopicMass: 44.95590828,
  },
  {
    number: 22,
    isotopes: [
      { nominal: 38, mass: 38.01145 },
      { nominal: 39, mass: 39.00236 },
      { nominal: 40, mass: 39.9905 },
      { nominal: 41, mass: 40.983148 },
      { nominal: 42, mass: 41.97304903 },
      { nominal: 43, mass: 42.9685225 },
      { nominal: 44, mass: 43.95968995 },
      { nominal: 45, mass: 44.95812198 },
      { nominal: 46, mass: 45.95262772, abundance: 0.0825 },
      { nominal: 47, mass: 46.95175879, abundance: 0.0744 },
      { nominal: 48, mass: 47.94794198, abundance: 0.7372 },
      { nominal: 49, mass: 48.94786568, abundance: 0.0541 },
      { nominal: 50, mass: 49.94478689, abundance: 0.0518 },
      { nominal: 51, mass: 50.94661065 },
      { nominal: 52, mass: 51.946893 },
      { nominal: 53, mass: 52.94973 },
      { nominal: 54, mass: 53.95105 },
      { nominal: 55, mass: 54.95527 },
      { nominal: 56, mass: 55.95791 },
      { nominal: 57, mass: 56.96364 },
      { nominal: 58, mass: 57.9666 },
      { nominal: 59, mass: 58.97247 },
      { nominal: 60, mass: 59.97603 },
      { nominal: 61, mass: 60.98245 },
      { nominal: 62, mass: 61.98651 },
      { nominal: 63, mass: 62.99375 },
    ],
    symbol: 'Ti',
    mass: 47.866744962721995,
    name: 'Titanium',
    monoisotopicMass: 47.94794198,
  },
  {
    number: 23,
    isotopes: [
      { nominal: 40, mass: 40.01276 },
      { nominal: 41, mass: 41.00021 },
      { nominal: 42, mass: 41.99182 },
      { nominal: 43, mass: 42.980766 },
      { nominal: 44, mass: 43.97411 },
      { nominal: 45, mass: 44.9657748 },
      { nominal: 46, mass: 45.96019878 },
      { nominal: 47, mass: 46.95490491 },
      { nominal: 48, mass: 47.9522522 },
      { nominal: 49, mass: 48.9485118 },
      { nominal: 50, mass: 49.94715601, abundance: 0.0025 },
      { nominal: 51, mass: 50.94395704, abundance: 0.9975 },
      { nominal: 52, mass: 51.94477301 },
      { nominal: 53, mass: 52.9443367 },
      { nominal: 54, mass: 53.946439 },
      { nominal: 55, mass: 54.94724 },
      { nominal: 56, mass: 55.95048 },
      { nominal: 57, mass: 56.95252 },
      { nominal: 58, mass: 57.95672 },
      { nominal: 59, mass: 58.95939 },
      { nominal: 60, mass: 59.96431 },
      { nominal: 61, mass: 60.96725 },
      { nominal: 62, mass: 61.97265 },
      { nominal: 63, mass: 62.97639 },
      { nominal: 64, mass: 63.98264 },
      { nominal: 65, mass: 64.9875 },
      { nominal: 66, mass: 65.99398 },
    ],
    symbol: 'V',
    mass: 50.941465037425004,
    name: 'Vanadium',
    monoisotopicMass: 50.94395704,
  },
  {
    number: 24,
    isotopes: [
      { nominal: 42, mass: 42.0067 },
      { nominal: 43, mass: 42.99753 },
      { nominal: 44, mass: 43.98536 },
      { nominal: 45, mass: 44.97905 },
      { nominal: 46, mass: 45.968359 },
      { nominal: 47, mass: 46.9628974 },
      { nominal: 48, mass: 47.9540291 },
      { nominal: 49, mass: 48.9513333 },
      { nominal: 50, mass: 49.94604183, abundance: 0.04345 },
      { nominal: 51, mass: 50.94476502 },
      { nominal: 52, mass: 51.94050623, abundance: 0.83789 },
      { nominal: 53, mass: 52.94064815, abundance: 0.09501 },
      { nominal: 54, mass: 53.93887916, abundance: 0.02365 },
      { nominal: 55, mass: 54.94083843 },
      { nominal: 56, mass: 55.9406531 },
      { nominal: 57, mass: 56.943613 },
      { nominal: 58, mass: 57.94435 },
      { nominal: 59, mass: 58.94859 },
      { nominal: 60, mass: 59.95008 },
      { nominal: 61, mass: 60.95442 },
      { nominal: 62, mass: 61.9561 },
      { nominal: 63, mass: 62.96165 },
      { nominal: 64, mass: 63.96408 },
      { nominal: 65, mass: 64.96996 },
      { nominal: 66, mass: 65.97366 },
      { nominal: 67, mass: 66.98016 },
      { nominal: 68, mass: 67.98403 },
    ],
    symbol: 'Cr',
    mass: 51.9961317554337,
    name: 'Chromium',
    monoisotopicMass: 51.94050623,
  },
  {
    number: 25,
    isotopes: [
      { nominal: 44, mass: 44.00715 },
      { nominal: 45, mass: 44.99449 },
      { nominal: 46, mass: 45.98609 },
      { nominal: 47, mass: 46.975775 },
      { nominal: 48, mass: 47.96852 },
      { nominal: 49, mass: 48.959595 },
      { nominal: 50, mass: 49.95423778 },
      { nominal: 51, mass: 50.94820847 },
      { nominal: 52, mass: 51.9455639 },
      { nominal: 53, mass: 52.94128889 },
      { nominal: 54, mass: 53.9403576 },
      { nominal: 55, mass: 54.93804391, abundance: 1 },
      { nominal: 56, mass: 55.93890369 },
      { nominal: 57, mass: 56.9382861 },
      { nominal: 58, mass: 57.9400666 },
      { nominal: 59, mass: 58.9403911 },
      { nominal: 60, mass: 59.9431366 },
      { nominal: 61, mass: 60.9444525 },
      { nominal: 62, mass: 61.94795 },
      { nominal: 63, mass: 62.9496647 },
      { nominal: 64, mass: 63.9538494 },
      { nominal: 65, mass: 64.9560198 },
      { nominal: 66, mass: 65.960547 },
      { nominal: 67, mass: 66.96424 },
      { nominal: 68, mass: 67.96962 },
      { nominal: 69, mass: 68.97366 },
      { nominal: 70, mass: 69.97937 },
      { nominal: 71, mass: 70.98368 },
    ],
    symbol: 'Mn',
    mass: 54.93804391,
    name: 'Manganese',
    monoisotopicMass: 54.93804391,
  },
  {
    number: 26,
    isotopes: [
      { nominal: 45, mass: 45.01442 },
      { nominal: 46, mass: 46.00063 },
      { nominal: 47, mass: 46.99185 },
      { nominal: 48, mass: 47.98023 },
      { nominal: 49, mass: 48.973429 },
      { nominal: 50, mass: 49.962975 },
      { nominal: 51, mass: 50.956841 },
      { nominal: 52, mass: 51.9481131 },
      { nominal: 53, mass: 52.9453064 },
      { nominal: 54, mass: 53.93960899, abundance: 0.05845 },
      { nominal: 55, mass: 54.93829199 },
      { nominal: 56, mass: 55.93493633, abundance: 0.91754 },
      { nominal: 57, mass: 56.93539284, abundance: 0.02119 },
      { nominal: 58, mass: 57.93327443, abundance: 0.00282 },
      { nominal: 59, mass: 58.93487434 },
      { nominal: 60, mass: 59.9340711 },
      { nominal: 61, mass: 60.9367462 },
      { nominal: 62, mass: 61.9367918 },
      { nominal: 63, mass: 62.9402727 },
      { nominal: 64, mass: 63.9409878 },
      { nominal: 65, mass: 64.9450115 },
      { nominal: 66, mass: 65.94625 },
      { nominal: 67, mass: 66.95054 },
      { nominal: 68, mass: 67.95295 },
      { nominal: 69, mass: 68.95807 },
      { nominal: 70, mass: 69.96102 },
      { nominal: 71, mass: 70.96672 },
      { nominal: 72, mass: 71.96983 },
      { nominal: 73, mass: 72.97572 },
      { nominal: 74, mass: 73.97935 },
    ],
    symbol: 'Fe',
    mass: 55.845144433865904,
    name: 'Iron',
    monoisotopicMass: 55.93493633,
  },
  {
    number: 27,
    isotopes: [
      { nominal: 47, mass: 47.01057 },
      { nominal: 48, mass: 48.00093 },
      { nominal: 49, mass: 48.98891 },
      { nominal: 50, mass: 49.98091 },
      { nominal: 51, mass: 50.970647 },
      { nominal: 52, mass: 51.96351 },
      { nominal: 53, mass: 52.9542041 },
      { nominal: 54, mass: 53.94845987 },
      { nominal: 55, mass: 54.9419972 },
      { nominal: 56, mass: 55.9398388 },
      { nominal: 57, mass: 56.93629057 },
      { nominal: 58, mass: 57.9357521 },
      { nominal: 59, mass: 58.93319429, abundance: 1 },
      { nominal: 60, mass: 59.9338163 },
      { nominal: 61, mass: 60.93247662 },
      { nominal: 62, mass: 61.934059 },
      { nominal: 63, mass: 62.9336 },
      { nominal: 64, mass: 63.935811 },
      { nominal: 65, mass: 64.9364621 },
      { nominal: 66, mass: 65.939443 },
      { nominal: 67, mass: 66.9406096 },
      { nominal: 68, mass: 67.94426 },
      { nominal: 69, mass: 68.94614 },
      { nominal: 70, mass: 69.94963 },
      { nominal: 71, mass: 70.95237 },
      { nominal: 72, mass: 71.95729 },
      { nominal: 73, mass: 72.96039 },
      { nominal: 74, mass: 73.96515 },
      { nominal: 75, mass: 74.96876 },
      { nominal: 76, mass: 75.97413 },
    ],
    symbol: 'Co',
    mass: 58.93319429,
    name: 'Cobalt',
    monoisotopicMass: 58.93319429,
  },
  {
    number: 28,
    isotopes: [
      { nominal: 48, mass: 48.01769 },
      { nominal: 49, mass: 49.0077 },
      { nominal: 50, mass: 49.99474 },
      { nominal: 51, mass: 50.98611 },
      { nominal: 52, mass: 51.9748 },
      { nominal: 53, mass: 52.96819 },
      { nominal: 54, mass: 53.957892 },
      { nominal: 55, mass: 54.95133063 },
      { nominal: 56, mass: 55.94212855 },
      { nominal: 57, mass: 56.93979218 },
      { nominal: 58, mass: 57.93534241, abundance: 0.68077 },
      { nominal: 59, mass: 58.9343462 },
      { nominal: 60, mass: 59.93078588, abundance: 0.26223 },
      { nominal: 61, mass: 60.93105557, abundance: 0.011399 },
      { nominal: 62, mass: 61.92834537, abundance: 0.036346 },
      { nominal: 63, mass: 62.92966963 },
      { nominal: 64, mass: 63.92796682, abundance: 0.009255 },
      { nominal: 65, mass: 64.93008517 },
      { nominal: 66, mass: 65.9291393 },
      { nominal: 67, mass: 66.9315694 },
      { nominal: 68, mass: 67.9318688 },
      { nominal: 69, mass: 68.9356103 },
      { nominal: 70, mass: 69.9364313 },
      { nominal: 71, mass: 70.940519 },
      { nominal: 72, mass: 71.9417859 },
      { nominal: 73, mass: 72.9462067 },
      { nominal: 74, mass: 73.94798 },
      { nominal: 75, mass: 74.9525 },
      { nominal: 76, mass: 75.95533 },
      { nominal: 77, mass: 76.96055 },
      { nominal: 78, mass: 77.96336 },
      { nominal: 79, mass: 78.97025 },
    ],
    symbol: 'Ni',
    mass: 58.69334710994765,
    name: 'Nickel',
    monoisotopicMass: 57.93534241,
  },
  {
    number: 29,
    isotopes: [
      { nominal: 52, mass: 51.99671 },
      { nominal: 53, mass: 52.98459 },
      { nominal: 54, mass: 53.97666 },
      { nominal: 55, mass: 54.96604 },
      { nominal: 56, mass: 55.95895 },
      { nominal: 57, mass: 56.9492125 },
      { nominal: 58, mass: 57.94453305 },
      { nominal: 59, mass: 58.93949748 },
      { nominal: 60, mass: 59.9373645 },
      { nominal: 61, mass: 60.9334576 },
      { nominal: 62, mass: 61.93259541 },
      { nominal: 63, mass: 62.92959772, abundance: 0.6915 },
      { nominal: 64, mass: 63.92976434 },
      { nominal: 65, mass: 64.9277897, abundance: 0.3085 },
      { nominal: 66, mass: 65.92886903 },
      { nominal: 67, mass: 66.9277303 },
      { nominal: 68, mass: 67.9296109 },
      { nominal: 69, mass: 68.9294293 },
      { nominal: 70, mass: 69.9323921 },
      { nominal: 71, mass: 70.9326768 },
      { nominal: 72, mass: 71.9358203 },
      { nominal: 73, mass: 72.9366744 },
      { nominal: 74, mass: 73.9398749 },
      { nominal: 75, mass: 74.9415226 },
      { nominal: 76, mass: 75.945275 },
      { nominal: 77, mass: 76.94792 },
      { nominal: 78, mass: 77.95223 },
      { nominal: 79, mass: 78.95502 },
      { nominal: 80, mass: 79.96089 },
      { nominal: 81, mass: 80.96587 },
      { nominal: 82, mass: 81.97244 },
    ],
    symbol: 'Cu',
    mass: 63.54603994583,
    name: 'Copper',
    monoisotopicMass: 62.92959772,
  },
  {
    number: 30,
    isotopes: [
      { nominal: 54, mass: 53.99204 },
      { nominal: 55, mass: 54.98398 },
      { nominal: 56, mass: 55.97254 },
      { nominal: 57, mass: 56.96506 },
      { nominal: 58, mass: 57.954591 },
      { nominal: 59, mass: 58.94931266 },
      { nominal: 60, mass: 59.9418421 },
      { nominal: 61, mass: 60.939507 },
      { nominal: 62, mass: 61.93433397 },
      { nominal: 63, mass: 62.9332115 },
      { nominal: 64, mass: 63.92914201, abundance: 0.4917 },
      { nominal: 65, mass: 64.92924077 },
      { nominal: 66, mass: 65.92603381, abundance: 0.2773 },
      { nominal: 67, mass: 66.92712775, abundance: 0.0404 },
      { nominal: 68, mass: 67.92484455, abundance: 0.1845 },
      { nominal: 69, mass: 68.9265507 },
      { nominal: 70, mass: 69.9253192, abundance: 0.0061 },
      { nominal: 71, mass: 70.9277196 },
      { nominal: 72, mass: 71.9268428 },
      { nominal: 73, mass: 72.9295826 },
      { nominal: 74, mass: 73.9294073 },
      { nominal: 75, mass: 74.9328402 },
      { nominal: 76, mass: 75.933115 },
      { nominal: 77, mass: 76.9368872 },
      { nominal: 78, mass: 77.9382892 },
      { nominal: 79, mass: 78.9426381 },
      { nominal: 80, mass: 79.9445529 },
      { nominal: 81, mass: 80.9504026 },
      { nominal: 82, mass: 81.95426 },
      { nominal: 83, mass: 82.96056 },
      { nominal: 84, mass: 83.96521 },
      { nominal: 85, mass: 84.97226 },
    ],
    symbol: 'Zn',
    mass: 65.37778252952499,
    name: 'Zinc',
    monoisotopicMass: 63.92914201,
  },
  {
    number: 31,
    isotopes: [
      { nominal: 56, mass: 55.99536 },
      { nominal: 57, mass: 56.9832 },
      { nominal: 58, mass: 57.97478 },
      { nominal: 59, mass: 58.96353 },
      { nominal: 60, mass: 59.95729 },
      { nominal: 61, mass: 60.949399 },
      { nominal: 62, mass: 61.94419025 },
      { nominal: 63, mass: 62.9392942 },
      { nominal: 64, mass: 63.9368404 },
      { nominal: 65, mass: 64.93273459 },
      { nominal: 66, mass: 65.9315894 },
      { nominal: 67, mass: 66.9282025 },
      { nominal: 68, mass: 67.9279805 },
      { nominal: 69, mass: 68.9255735, abundance: 0.60108 },
      { nominal: 70, mass: 69.9260219 },
      { nominal: 71, mass: 70.92470258, abundance: 0.39892 },
      { nominal: 72, mass: 71.92636747 },
      { nominal: 73, mass: 72.9251747 },
      { nominal: 74, mass: 73.9269457 },
      { nominal: 75, mass: 74.9265002 },
      { nominal: 76, mass: 75.9288276 },
      { nominal: 77, mass: 76.9291543 },
      { nominal: 78, mass: 77.9316088 },
      { nominal: 79, mass: 78.9328523 },
      { nominal: 80, mass: 79.9364208 },
      { nominal: 81, mass: 80.9381338 },
      { nominal: 82, mass: 81.9431765 },
      { nominal: 83, mass: 82.9471203 },
      { nominal: 84, mass: 83.95246 },
      { nominal: 85, mass: 84.95699 },
      { nominal: 86, mass: 85.96301 },
      { nominal: 87, mass: 86.96824 },
    ],
    symbol: 'Ga',
    mass: 69.7230660725936,
    name: 'Gallium',
    monoisotopicMass: 68.9255735,
  },
  {
    number: 32,
    isotopes: [
      { nominal: 58, mass: 57.99172 },
      { nominal: 59, mass: 58.98249 },
      { nominal: 60, mass: 59.97036 },
      { nominal: 61, mass: 60.96379 },
      { nominal: 62, mass: 61.95502 },
      { nominal: 63, mass: 62.949628 },
      { nominal: 64, mass: 63.9416899 },
      { nominal: 65, mass: 64.9393681 },
      { nominal: 66, mass: 65.9338621 },
      { nominal: 67, mass: 66.9327339 },
      { nominal: 68, mass: 67.9280953 },
      { nominal: 69, mass: 68.9279645 },
      { nominal: 70, mass: 69.92424875, abundance: 0.2057 },
      { nominal: 71, mass: 70.92495233 },
      { nominal: 72, mass: 71.922075826, abundance: 0.2745 },
      { nominal: 73, mass: 72.923458956, abundance: 0.0775 },
      { nominal: 74, mass: 73.921177761, abundance: 0.365 },
      { nominal: 75, mass: 74.92285837 },
      { nominal: 76, mass: 75.921402726, abundance: 0.0773 },
      { nominal: 77, mass: 76.923549843 },
      { nominal: 78, mass: 77.9228529 },
      { nominal: 79, mass: 78.92536 },
      { nominal: 80, mass: 79.9253508 },
      { nominal: 81, mass: 80.9288329 },
      { nominal: 82, mass: 81.929774 },
      { nominal: 83, mass: 82.9345391 },
      { nominal: 84, mass: 83.9375751 },
      { nominal: 85, mass: 84.9429697 },
      { nominal: 86, mass: 85.94658 },
      { nominal: 87, mass: 86.95268 },
      { nominal: 88, mass: 87.95691 },
      { nominal: 89, mass: 88.96379 },
      { nominal: 90, mass: 89.96863 },
    ],
    symbol: 'Ge',
    mass: 72.6275501646868,
    name: 'Germanium',
    monoisotopicMass: 73.921177761,
  },
  {
    number: 33,
    isotopes: [
      { nominal: 60, mass: 59.99388 },
      { nominal: 61, mass: 60.98112 },
      { nominal: 62, mass: 61.97361 },
      { nominal: 63, mass: 62.9639 },
      { nominal: 64, mass: 63.95743 },
      { nominal: 65, mass: 64.949611 },
      { nominal: 66, mass: 65.9441488 },
      { nominal: 67, mass: 66.93925111 },
      { nominal: 68, mass: 67.9367741 },
      { nominal: 69, mass: 68.932246 },
      { nominal: 70, mass: 69.930926 },
      { nominal: 71, mass: 70.9271138 },
      { nominal: 72, mass: 71.9267523 },
      { nominal: 73, mass: 72.9238291 },
      { nominal: 74, mass: 73.9239286 },
      { nominal: 75, mass: 74.92159457, abundance: 1 },
      { nominal: 76, mass: 75.92239202 },
      { nominal: 77, mass: 76.9206476 },
      { nominal: 78, mass: 77.921828 },
      { nominal: 79, mass: 78.9209484 },
      { nominal: 80, mass: 79.9224746 },
      { nominal: 81, mass: 80.9221323 },
      { nominal: 82, mass: 81.9247412 },
      { nominal: 83, mass: 82.9252069 },
      { nominal: 84, mass: 83.9293033 },
      { nominal: 85, mass: 84.9321637 },
      { nominal: 86, mass: 85.9367015 },
      { nominal: 87, mass: 86.9402917 },
      { nominal: 88, mass: 87.94555 },
      { nominal: 89, mass: 88.94976 },
      { nominal: 90, mass: 89.95563 },
      { nominal: 91, mass: 90.96039 },
      { nominal: 92, mass: 91.96674 },
    ],
    symbol: 'As',
    mass: 74.92159457,
    name: 'Arsenic',
    monoisotopicMass: 74.92159457,
  },
  {
    number: 34,
    isotopes: [
      { nominal: 64, mass: 63.97109 },
      { nominal: 65, mass: 64.9644 },
      { nominal: 66, mass: 65.95559 },
      { nominal: 67, mass: 66.949994 },
      { nominal: 68, mass: 67.94182524 },
      { nominal: 69, mass: 68.9394148 },
      { nominal: 70, mass: 69.9335155 },
      { nominal: 71, mass: 70.9322094 },
      { nominal: 72, mass: 71.9271405 },
      { nominal: 73, mass: 72.9267549 },
      { nominal: 74, mass: 73.922475934, abundance: 0.0089 },
      { nominal: 75, mass: 74.92252287 },
      { nominal: 76, mass: 75.919213704, abundance: 0.0937 },
      { nominal: 77, mass: 76.919914154, abundance: 0.0763 },
      { nominal: 78, mass: 77.91730928, abundance: 0.2377 },
      { nominal: 79, mass: 78.91849929 },
      { nominal: 80, mass: 79.9165218, abundance: 0.4961 },
      { nominal: 81, mass: 80.917993 },
      { nominal: 82, mass: 81.9166995, abundance: 0.0873 },
      { nominal: 83, mass: 82.9191186 },
      { nominal: 84, mass: 83.9184668 },
      { nominal: 85, mass: 84.9222608 },
      { nominal: 86, mass: 85.9243117 },
      { nominal: 87, mass: 86.9286886 },
      { nominal: 88, mass: 87.9314175 },
      { nominal: 89, mass: 88.9366691 },
      { nominal: 90, mass: 89.9401 },
      { nominal: 91, mass: 90.94596 },
      { nominal: 92, mass: 91.94984 },
      { nominal: 93, mass: 92.95629 },
      { nominal: 94, mass: 93.96049 },
      { nominal: 95, mass: 94.9673 },
    ],
    symbol: 'Se',
    mass: 78.95938855701361,
    name: 'Selenium',
    monoisotopicMass: 79.9165218,
  },
  {
    number: 35,
    isotopes: [
      { nominal: 67, mass: 66.96465 },
      { nominal: 68, mass: 67.95873 },
      { nominal: 69, mass: 68.950497 },
      { nominal: 70, mass: 69.944792 },
      { nominal: 71, mass: 70.9393422 },
      { nominal: 72, mass: 71.9365886 },
      { nominal: 73, mass: 72.9316715 },
      { nominal: 74, mass: 73.9299102 },
      { nominal: 75, mass: 74.9258105 },
      { nominal: 76, mass: 75.924542 },
      { nominal: 77, mass: 76.9213792 },
      { nominal: 78, mass: 77.9211459 },
      { nominal: 79, mass: 78.9183376, abundance: 0.5069 },
      { nominal: 80, mass: 79.9185298 },
      { nominal: 81, mass: 80.9162897, abundance: 0.4931 },
      { nominal: 82, mass: 81.9168032 },
      { nominal: 83, mass: 82.9151756 },
      { nominal: 84, mass: 83.916496 },
      { nominal: 85, mass: 84.9156458 },
      { nominal: 86, mass: 85.9188054 },
      { nominal: 87, mass: 86.920674 },
      { nominal: 88, mass: 87.9240833 },
      { nominal: 89, mass: 88.9267046 },
      { nominal: 90, mass: 89.9312928 },
      { nominal: 91, mass: 90.9343986 },
      { nominal: 92, mass: 91.9396316 },
      { nominal: 93, mass: 92.94313 },
      { nominal: 94, mass: 93.9489 },
      { nominal: 95, mass: 94.95301 },
      { nominal: 96, mass: 95.95903 },
      { nominal: 97, mass: 96.96344 },
      { nominal: 98, mass: 97.96946 },
    ],
    symbol: 'Br',
    mass: 79.90352778050999,
    name: 'Bromine',
    monoisotopicMass: 78.9183376,
  },
  {
    number: 36,
    isotopes: [
      { nominal: 69, mass: 68.96518 },
      { nominal: 70, mass: 69.95604 },
      { nominal: 71, mass: 70.95027 },
      { nominal: 72, mass: 71.9420924 },
      { nominal: 73, mass: 72.9392892 },
      { nominal: 74, mass: 73.933084 },
      { nominal: 75, mass: 74.9309457 },
      { nominal: 76, mass: 75.9259103 },
      { nominal: 77, mass: 76.92467 },
      { nominal: 78, mass: 77.92036494, abundance: 0.00355 },
      { nominal: 79, mass: 78.9200829 },
      { nominal: 80, mass: 79.91637808, abundance: 0.02286 },
      { nominal: 81, mass: 80.9165912 },
      { nominal: 82, mass: 81.91348273, abundance: 0.11593 },
      { nominal: 83, mass: 82.91412716, abundance: 0.115 },
      { nominal: 84, mass: 83.9114977282, abundance: 0.56987 },
      { nominal: 85, mass: 84.9125273 },
      { nominal: 86, mass: 85.9106106269, abundance: 0.17279 },
      { nominal: 87, mass: 86.91335476 },
      { nominal: 88, mass: 87.9144479 },
      { nominal: 89, mass: 88.9178355 },
      { nominal: 90, mass: 89.9195279 },
      { nominal: 91, mass: 90.9238063 },
      { nominal: 92, mass: 91.9261731 },
      { nominal: 93, mass: 92.9311472 },
      { nominal: 94, mass: 93.93414 },
      { nominal: 95, mass: 94.939711 },
      { nominal: 96, mass: 95.943017 },
      { nominal: 97, mass: 96.94909 },
      { nominal: 98, mass: 97.95243 },
      { nominal: 99, mass: 98.95839 },
      { nominal: 100, mass: 99.96237 },
      { nominal: 101, mass: 100.96873 },
    ],
    symbol: 'Kr',
    mass: 83.7979999953261,
    name: 'Krypton',
    monoisotopicMass: 83.9114977282,
  },
  {
    number: 37,
    isotopes: [
      { nominal: 71, mass: 70.96532 },
      { nominal: 72, mass: 71.95908 },
      { nominal: 73, mass: 72.95053 },
      { nominal: 74, mass: 73.9442659 },
      { nominal: 75, mass: 74.9385732 },
      { nominal: 76, mass: 75.935073 },
      { nominal: 77, mass: 76.9304016 },
      { nominal: 78, mass: 77.9281419 },
      { nominal: 79, mass: 78.9239899 },
      { nominal: 80, mass: 79.9225164 },
      { nominal: 81, mass: 80.9189939 },
      { nominal: 82, mass: 81.918209 },
      { nominal: 83, mass: 82.9151142 },
      { nominal: 84, mass: 83.9143752 },
      { nominal: 85, mass: 84.9117897379, abundance: 0.7217 },
      { nominal: 86, mass: 85.91116743 },
      { nominal: 87, mass: 86.909180531, abundance: 0.2783 },
      { nominal: 88, mass: 87.91131559 },
      { nominal: 89, mass: 88.9122783 },
      { nominal: 90, mass: 89.9147985 },
      { nominal: 91, mass: 90.9165372 },
      { nominal: 92, mass: 91.9197284 },
      { nominal: 93, mass: 92.9220393 },
      { nominal: 94, mass: 93.9263948 },
      { nominal: 95, mass: 94.92926 },
      { nominal: 96, mass: 95.9341334 },
      { nominal: 97, mass: 96.9371771 },
      { nominal: 98, mass: 97.9416869 },
      { nominal: 99, mass: 98.94503 },
      { nominal: 100, mass: 99.95003 },
      { nominal: 101, mass: 100.95404 },
      { nominal: 102, mass: 101.95952 },
      { nominal: 103, mass: 102.96392 },
    ],
    symbol: 'Rb',
    mass: 85.46766359561973,
    name: 'Rubidium',
    monoisotopicMass: 84.9117897379,
  },
  {
    number: 38,
    isotopes: [
      { nominal: 73, mass: 72.9657 },
      { nominal: 74, mass: 73.95617 },
      { nominal: 75, mass: 74.94995 },
      { nominal: 76, mass: 75.941763 },
      { nominal: 77, mass: 76.9379455 },
      { nominal: 78, mass: 77.93218 },
      { nominal: 79, mass: 78.9297077 },
      { nominal: 80, mass: 79.9245175 },
      { nominal: 81, mass: 80.9232114 },
      { nominal: 82, mass: 81.9183999 },
      { nominal: 83, mass: 82.9175544 },
      { nominal: 84, mass: 83.9134191, abundance: 0.0056 },
      { nominal: 85, mass: 84.912932 },
      { nominal: 86, mass: 85.9092606, abundance: 0.0986 },
      { nominal: 87, mass: 86.9088775, abundance: 0.07 },
      { nominal: 88, mass: 87.9056125, abundance: 0.8258 },
      { nominal: 89, mass: 88.9074511 },
      { nominal: 90, mass: 89.90773 },
      { nominal: 91, mass: 90.9101954 },
      { nominal: 92, mass: 91.9110382 },
      { nominal: 93, mass: 92.9140242 },
      { nominal: 94, mass: 93.9153556 },
      { nominal: 95, mass: 94.9193529 },
      { nominal: 96, mass: 95.9217066 },
      { nominal: 97, mass: 96.926374 },
      { nominal: 98, mass: 97.9286888 },
      { nominal: 99, mass: 98.9328907 },
      { nominal: 100, mass: 99.93577 },
      { nominal: 101, mass: 100.940352 },
      { nominal: 102, mass: 101.943791 },
      { nominal: 103, mass: 102.94909 },
      { nominal: 104, mass: 103.95265 },
      { nominal: 105, mass: 104.95855 },
      { nominal: 106, mass: 105.96265 },
      { nominal: 107, mass: 106.96897 },
    ],
    symbol: 'Sr',
    mass: 87.61664446962,
    name: 'Strontium',
    monoisotopicMass: 87.9056125,
  },
  {
    number: 39,
    isotopes: [
      { nominal: 76, mass: 75.95856 },
      { nominal: 77, mass: 76.949781 },
      { nominal: 78, mass: 77.94361 },
      { nominal: 79, mass: 78.93735 },
      { nominal: 80, mass: 79.9343561 },
      { nominal: 81, mass: 80.9294556 },
      { nominal: 82, mass: 81.9269314 },
      { nominal: 83, mass: 82.922485 },
      { nominal: 84, mass: 83.9206721 },
      { nominal: 85, mass: 84.916433 },
      { nominal: 86, mass: 85.914886 },
      { nominal: 87, mass: 86.9108761 },
      { nominal: 88, mass: 87.9095016 },
      { nominal: 89, mass: 88.9058403, abundance: 1 },
      { nominal: 90, mass: 89.9071439 },
      { nominal: 91, mass: 90.9072974 },
      { nominal: 92, mass: 91.9089451 },
      { nominal: 93, mass: 92.909578 },
      { nominal: 94, mass: 93.9115906 },
      { nominal: 95, mass: 94.9128161 },
      { nominal: 96, mass: 95.9158968 },
      { nominal: 97, mass: 96.9182741 },
      { nominal: 98, mass: 97.9223821 },
      { nominal: 99, mass: 98.924148 },
      { nominal: 100, mass: 99.927715 },
      { nominal: 101, mass: 100.9301477 },
      { nominal: 102, mass: 101.9343277 },
      { nominal: 103, mass: 102.937243 },
      { nominal: 104, mass: 103.94196 },
      { nominal: 105, mass: 104.94544 },
      { nominal: 106, mass: 105.95056 },
      { nominal: 107, mass: 106.95452 },
      { nominal: 108, mass: 107.95996 },
      { nominal: 109, mass: 108.96436 },
    ],
    symbol: 'Y',
    mass: 88.9058403,
    name: 'Yttrium',
    monoisotopicMass: 88.9058403,
  },
  {
    number: 40,
    isotopes: [
      { nominal: 78, mass: 77.95566 },
      { nominal: 79, mass: 78.94948 },
      { nominal: 80, mass: 79.9404 },
      { nominal: 81, mass: 80.93731 },
      { nominal: 82, mass: 81.93135 },
      { nominal: 83, mass: 82.9292421 },
      { nominal: 84, mass: 83.9233269 },
      { nominal: 85, mass: 84.9214444 },
      { nominal: 86, mass: 85.9162972 },
      { nominal: 87, mass: 86.914818 },
      { nominal: 88, mass: 87.9102213 },
      { nominal: 89, mass: 88.9088814 },
      { nominal: 90, mass: 89.9046977, abundance: 0.5145 },
      { nominal: 91, mass: 90.9056396, abundance: 0.1122 },
      { nominal: 92, mass: 91.9050347, abundance: 0.1715 },
      { nominal: 93, mass: 92.9064699 },
      { nominal: 94, mass: 93.9063108, abundance: 0.1738 },
      { nominal: 95, mass: 94.9080385 },
      { nominal: 96, mass: 95.9082714, abundance: 0.028 },
      { nominal: 97, mass: 96.9109512 },
      { nominal: 98, mass: 97.9127289 },
      { nominal: 99, mass: 98.916667 },
      { nominal: 100, mass: 99.9180006 },
      { nominal: 101, mass: 100.921448 },
      { nominal: 102, mass: 101.9231409 },
      { nominal: 103, mass: 102.927191 },
      { nominal: 104, mass: 103.929436 },
      { nominal: 105, mass: 104.934008 },
      { nominal: 106, mass: 105.93676 },
      { nominal: 107, mass: 106.94174 },
      { nominal: 108, mass: 107.94487 },
      { nominal: 109, mass: 108.95041 },
      { nominal: 110, mass: 109.95396 },
      { nominal: 111, mass: 110.95968 },
      { nominal: 112, mass: 111.9637 },
    ],
    symbol: 'Zr',
    mass: 91.22364159706,
    name: 'Zirconium',
    monoisotopicMass: 89.9046977,
  },
  {
    number: 41,
    isotopes: [
      { nominal: 81, mass: 80.9496 },
      { nominal: 82, mass: 81.94396 },
      { nominal: 83, mass: 82.93729 },
      { nominal: 84, mass: 83.93449 },
      { nominal: 85, mass: 84.9288458 },
      { nominal: 86, mass: 85.9257828 },
      { nominal: 87, mass: 86.9206937 },
      { nominal: 88, mass: 87.918222 },
      { nominal: 89, mass: 88.913445 },
      { nominal: 90, mass: 89.9112584 },
      { nominal: 91, mass: 90.9069897 },
      { nominal: 92, mass: 91.9071881 },
      { nominal: 93, mass: 92.906373, abundance: 1 },
      { nominal: 94, mass: 93.9072788 },
      { nominal: 95, mass: 94.9068324 },
      { nominal: 96, mass: 95.9080973 },
      { nominal: 97, mass: 96.9080959 },
      { nominal: 98, mass: 97.9103265 },
      { nominal: 99, mass: 98.911613 },
      { nominal: 100, mass: 99.9143276 },
      { nominal: 101, mass: 100.9153103 },
      { nominal: 102, mass: 101.9180772 },
      { nominal: 103, mass: 102.9194572 },
      { nominal: 104, mass: 103.9228925 },
      { nominal: 105, mass: 104.9249465 },
      { nominal: 106, mass: 105.9289317 },
      { nominal: 107, mass: 106.9315937 },
      { nominal: 108, mass: 107.9360748 },
      { nominal: 109, mass: 108.93922 },
      { nominal: 110, mass: 109.94403 },
      { nominal: 111, mass: 110.94753 },
      { nominal: 112, mass: 111.95247 },
      { nominal: 113, mass: 112.95651 },
      { nominal: 114, mass: 113.96201 },
      { nominal: 115, mass: 114.96634 },
    ],
    symbol: 'Nb',
    mass: 92.906373,
    name: 'Niobium',
    monoisotopicMass: 92.906373,
  },
  {
    number: 42,
    isotopes: [
      { nominal: 83, mass: 82.94988 },
      { nominal: 84, mass: 83.94149 },
      { nominal: 85, mass: 84.938261 },
      { nominal: 86, mass: 85.9311748 },
      { nominal: 87, mass: 86.9281962 },
      { nominal: 88, mass: 87.9219678 },
      { nominal: 89, mass: 88.9194682 },
      { nominal: 90, mass: 89.9139309 },
      { nominal: 91, mass: 90.9117453 },
      { nominal: 92, mass: 91.90680796, abundance: 0.1453 },
      { nominal: 93, mass: 92.90680958 },
      { nominal: 94, mass: 93.9050849, abundance: 0.0915 },
      { nominal: 95, mass: 94.90583877, abundance: 0.1584 },
      { nominal: 96, mass: 95.90467612, abundance: 0.1667 },
      { nominal: 97, mass: 96.90601812, abundance: 0.096 },
      { nominal: 98, mass: 97.90540482, abundance: 0.2439 },
      { nominal: 99, mass: 98.90770851 },
      { nominal: 100, mass: 99.9074718, abundance: 0.0982 },
      { nominal: 101, mass: 100.9103414 },
      { nominal: 102, mass: 101.9102834 },
      { nominal: 103, mass: 102.913079 },
      { nominal: 104, mass: 103.9137344 },
      { nominal: 105, mass: 104.916969 },
      { nominal: 106, mass: 105.918259 },
      { nominal: 107, mass: 106.922106 },
      { nominal: 108, mass: 107.924033 },
      { nominal: 109, mass: 108.928424 },
      { nominal: 110, mass: 109.930704 },
      { nominal: 111, mass: 110.935654 },
      { nominal: 112, mass: 111.93831 },
      { nominal: 113, mass: 112.94335 },
      { nominal: 114, mass: 113.94653 },
      { nominal: 115, mass: 114.95196 },
      { nominal: 116, mass: 115.95545 },
      { nominal: 117, mass: 116.96117 },
    ],
    symbol: 'Mo',
    mass: 95.959788541188,
    name: 'Molybdenum',
    monoisotopicMass: 97.90540482,
  },
  {
    number: 43,
    isotopes: [
      { nominal: 85, mass: 84.95058 },
      { nominal: 86, mass: 85.94493 },
      { nominal: 87, mass: 86.9380672 },
      { nominal: 88, mass: 87.93378 },
      { nominal: 89, mass: 88.9276487 },
      { nominal: 90, mass: 89.9240739 },
      { nominal: 91, mass: 90.9184254 },
      { nominal: 92, mass: 91.9152698 },
      { nominal: 93, mass: 92.910246 },
      { nominal: 94, mass: 93.9096536 },
      { nominal: 95, mass: 94.9076536 },
      { nominal: 96, mass: 95.907868 },
      { nominal: 97, mass: 96.9063667 },
      { nominal: 98, mass: 97.9072124 },
      { nominal: 99, mass: 98.9062508 },
      { nominal: 100, mass: 99.9076539 },
      { nominal: 101, mass: 100.907309 },
      { nominal: 102, mass: 101.9092097 },
      { nominal: 103, mass: 102.909176 },
      { nominal: 104, mass: 103.911425 },
      { nominal: 105, mass: 104.911655 },
      { nominal: 106, mass: 105.914358 },
      { nominal: 107, mass: 106.9154606 },
      { nominal: 108, mass: 107.9184957 },
      { nominal: 109, mass: 108.920256 },
      { nominal: 110, mass: 109.923744 },
      { nominal: 111, mass: 110.925901 },
      { nominal: 112, mass: 111.9299458 },
      { nominal: 113, mass: 112.932569 },
      { nominal: 114, mass: 113.93691 },
      { nominal: 115, mass: 114.93998 },
      { nominal: 116, mass: 115.94476 },
      { nominal: 117, mass: 116.94806 },
      { nominal: 118, mass: 117.95299 },
      { nominal: 119, mass: 118.95666 },
      { nominal: 120, mass: 119.96187 },
    ],
    symbol: 'Tc',
    mass: null,
    name: 'Technetium',
  },
  {
    number: 44,
    isotopes: [
      { nominal: 87, mass: 86.95069 },
      { nominal: 88, mass: 87.9416 },
      { nominal: 89, mass: 88.93762 },
      { nominal: 90, mass: 89.9303444 },
      { nominal: 91, mass: 90.9267419 },
      { nominal: 92, mass: 91.9202344 },
      { nominal: 93, mass: 92.9171044 },
      { nominal: 94, mass: 93.9113429 },
      { nominal: 95, mass: 94.910406 },
      { nominal: 96, mass: 95.90759025, abundance: 0.0554 },
      { nominal: 97, mass: 96.9075471 },
      { nominal: 98, mass: 97.9052868, abundance: 0.0187 },
      { nominal: 99, mass: 98.9059341, abundance: 0.1276 },
      { nominal: 100, mass: 99.9042143, abundance: 0.126 },
      { nominal: 101, mass: 100.9055769, abundance: 0.1706 },
      { nominal: 102, mass: 101.9043441, abundance: 0.3155 },
      { nominal: 103, mass: 102.9063186 },
      { nominal: 104, mass: 103.9054275, abundance: 0.1862 },
      { nominal: 105, mass: 104.9077476 },
      { nominal: 106, mass: 105.9073291 },
      { nominal: 107, mass: 106.909972 },
      { nominal: 108, mass: 107.910188 },
      { nominal: 109, mass: 108.913326 },
      { nominal: 110, mass: 109.9140407 },
      { nominal: 111, mass: 110.91757 },
      { nominal: 112, mass: 111.918809 },
      { nominal: 113, mass: 112.922844 },
      { nominal: 114, mass: 113.9246136 },
      { nominal: 115, mass: 114.92882 },
      { nominal: 116, mass: 115.9312192 },
      { nominal: 117, mass: 116.9361 },
      { nominal: 118, mass: 117.93853 },
      { nominal: 119, mass: 118.94357 },
      { nominal: 120, mass: 119.94631 },
      { nominal: 121, mass: 120.95164 },
      { nominal: 122, mass: 121.95447 },
      { nominal: 123, mass: 122.95989 },
      { nominal: 124, mass: 123.96305 },
    ],
    symbol: 'Ru',
    mass: 101.06494013916,
    name: 'Ruthenium',
    monoisotopicMass: 101.9043441,
  },
  {
    number: 45,
    isotopes: [
      { nominal: 89, mass: 88.95058 },
      { nominal: 90, mass: 89.94422 },
      { nominal: 91, mass: 90.93688 },
      { nominal: 92, mass: 91.9323677 },
      { nominal: 93, mass: 92.9259128 },
      { nominal: 94, mass: 93.9217305 },
      { nominal: 95, mass: 94.9158979 },
      { nominal: 96, mass: 95.914453 },
      { nominal: 97, mass: 96.911329 },
      { nominal: 98, mass: 97.910708 },
      { nominal: 99, mass: 98.9081282 },
      { nominal: 100, mass: 99.908117 },
      { nominal: 101, mass: 100.9061606 },
      { nominal: 102, mass: 101.9068374 },
      { nominal: 103, mass: 102.905498, abundance: 1 },
      { nominal: 104, mass: 103.9066492 },
      { nominal: 105, mass: 104.9056885 },
      { nominal: 106, mass: 105.9072868 },
      { nominal: 107, mass: 106.906748 },
      { nominal: 108, mass: 107.908714 },
      { nominal: 109, mass: 108.9087488 },
      { nominal: 110, mass: 109.911079 },
      { nominal: 111, mass: 110.9116423 },
      { nominal: 112, mass: 111.914403 },
      { nominal: 113, mass: 112.9154393 },
      { nominal: 114, mass: 113.918718 },
      { nominal: 115, mass: 114.9203116 },
      { nominal: 116, mass: 115.924059 },
      { nominal: 117, mass: 116.9260354 },
      { nominal: 118, mass: 117.93034 },
      { nominal: 119, mass: 118.932557 },
      { nominal: 120, mass: 119.93686 },
      { nominal: 121, mass: 120.93942 },
      { nominal: 122, mass: 121.94399 },
      { nominal: 123, mass: 122.94685 },
      { nominal: 124, mass: 123.95151 },
      { nominal: 125, mass: 124.95469 },
      { nominal: 126, mass: 125.95946 },
    ],
    symbol: 'Rh',
    mass: 102.905498,
    name: 'Rhodium',
    monoisotopicMass: 102.905498,
  },
  {
    number: 46,
    isotopes: [
      { nominal: 91, mass: 90.95032 },
      { nominal: 92, mass: 91.94088 },
      { nominal: 93, mass: 92.93651 },
      { nominal: 94, mass: 93.9290376 },
      { nominal: 95, mass: 94.9248898 },
      { nominal: 96, mass: 95.9182151 },
      { nominal: 97, mass: 96.916472 },
      { nominal: 98, mass: 97.9126983 },
      { nominal: 99, mass: 98.9117748 },
      { nominal: 100, mass: 99.908505 },
      { nominal: 101, mass: 100.9082864 },
      { nominal: 102, mass: 101.9056022, abundance: 0.0102 },
      { nominal: 103, mass: 102.9060809 },
      { nominal: 104, mass: 103.9040305, abundance: 0.1114 },
      { nominal: 105, mass: 104.9050796, abundance: 0.2233 },
      { nominal: 106, mass: 105.9034804, abundance: 0.2733 },
      { nominal: 107, mass: 106.9051282 },
      { nominal: 108, mass: 107.9038916, abundance: 0.2646 },
      { nominal: 109, mass: 108.9059504 },
      { nominal: 110, mass: 109.9051722, abundance: 0.1172 },
      { nominal: 111, mass: 110.90768968 },
      { nominal: 112, mass: 111.9073297 },
      { nominal: 113, mass: 112.910261 },
      { nominal: 114, mass: 113.9103686 },
      { nominal: 115, mass: 114.913659 },
      { nominal: 116, mass: 115.914297 },
      { nominal: 117, mass: 116.9179547 },
      { nominal: 118, mass: 117.9190667 },
      { nominal: 119, mass: 118.9233402 },
      { nominal: 120, mass: 119.9245511 },
      { nominal: 121, mass: 120.9289503 },
      { nominal: 122, mass: 121.930632 },
      { nominal: 123, mass: 122.93514 },
      { nominal: 124, mass: 123.93714 },
      { nominal: 125, mass: 124.94179 },
      { nominal: 126, mass: 125.94416 },
      { nominal: 127, mass: 126.94907 },
      { nominal: 128, mass: 127.95183 },
    ],
    symbol: 'Pd',
    mass: 106.41532750734,
    name: 'Palladium',
    monoisotopicMass: 105.9034804,
  },
  {
    number: 47,
    isotopes: [
      { nominal: 93, mass: 92.95033 },
      { nominal: 94, mass: 93.94373 },
      { nominal: 95, mass: 94.93602 },
      { nominal: 96, mass: 95.930744 },
      { nominal: 97, mass: 96.92397 },
      { nominal: 98, mass: 97.92156 },
      { nominal: 99, mass: 98.9176458 },
      { nominal: 100, mass: 99.9161154 },
      { nominal: 101, mass: 100.912684 },
      { nominal: 102, mass: 101.9117047 },
      { nominal: 103, mass: 102.9089631 },
      { nominal: 104, mass: 103.9086239 },
      { nominal: 105, mass: 104.9065256 },
      { nominal: 106, mass: 105.9066636 },
      { nominal: 107, mass: 106.9050916, abundance: 0.51839 },
      { nominal: 108, mass: 107.9059503 },
      { nominal: 109, mass: 108.9047553, abundance: 0.48161 },
      { nominal: 110, mass: 109.9061102 },
      { nominal: 111, mass: 110.9052959 },
      { nominal: 112, mass: 111.9070486 },
      { nominal: 113, mass: 112.906573 },
      { nominal: 114, mass: 113.908823 },
      { nominal: 115, mass: 114.908767 },
      { nominal: 116, mass: 115.9113868 },
      { nominal: 117, mass: 116.911774 },
      { nominal: 118, mass: 117.9145955 },
      { nominal: 119, mass: 118.91557 },
      { nominal: 120, mass: 119.9187848 },
      { nominal: 121, mass: 120.920125 },
      { nominal: 122, mass: 121.923664 },
      { nominal: 123, mass: 122.925337 },
      { nominal: 124, mass: 123.92893 },
      { nominal: 125, mass: 124.93105 },
      { nominal: 126, mass: 125.93475 },
      { nominal: 127, mass: 126.93711 },
      { nominal: 128, mass: 127.94106 },
      { nominal: 129, mass: 128.94395 },
      { nominal: 130, mass: 129.9507 },
    ],
    symbol: 'Ag',
    mass: 107.868149634557,
    name: 'Silver',
    monoisotopicMass: 106.9050916,
  },
  {
    number: 48,
    isotopes: [
      { nominal: 95, mass: 94.94994 },
      { nominal: 96, mass: 95.94034 },
      { nominal: 97, mass: 96.9351 },
      { nominal: 98, mass: 97.927389 },
      { nominal: 99, mass: 98.9249258 },
      { nominal: 100, mass: 99.9203488 },
      { nominal: 101, mass: 100.9185862 },
      { nominal: 102, mass: 101.914482 },
      { nominal: 103, mass: 102.9134165 },
      { nominal: 104, mass: 103.9098564 },
      { nominal: 105, mass: 104.9094639 },
      { nominal: 106, mass: 105.9064599, abundance: 0.0125 },
      { nominal: 107, mass: 106.9066121 },
      { nominal: 108, mass: 107.9041834, abundance: 0.0089 },
      { nominal: 109, mass: 108.9049867 },
      { nominal: 110, mass: 109.90300661, abundance: 0.1249 },
      { nominal: 111, mass: 110.90418287, abundance: 0.128 },
      { nominal: 112, mass: 111.90276287, abundance: 0.2413 },
      { nominal: 113, mass: 112.90440813, abundance: 0.1222 },
      { nominal: 114, mass: 113.90336509, abundance: 0.2873 },
      { nominal: 115, mass: 114.90543751 },
      { nominal: 116, mass: 115.90476315, abundance: 0.0749 },
      { nominal: 117, mass: 116.907226 },
      { nominal: 118, mass: 117.906922 },
      { nominal: 119, mass: 118.909847 },
      { nominal: 120, mass: 119.9098681 },
      { nominal: 121, mass: 120.9129637 },
      { nominal: 122, mass: 121.9134591 },
      { nominal: 123, mass: 122.9168925 },
      { nominal: 124, mass: 123.9176574 },
      { nominal: 125, mass: 124.9212576 },
      { nominal: 126, mass: 125.9224291 },
      { nominal: 127, mass: 126.926472 },
      { nominal: 128, mass: 127.9278129 },
      { nominal: 129, mass: 128.93182 },
      { nominal: 130, mass: 129.93394 },
      { nominal: 131, mass: 130.9406 },
      { nominal: 132, mass: 131.94604 },
      { nominal: 133, mass: 132.95285 },
    ],
    symbol: 'Cd',
    mass: 112.411557818268,
    name: 'Cadmium',
    monoisotopicMass: 113.90336509,
  },
  {
    number: 49,
    isotopes: [
      { nominal: 97, mass: 96.94934 },
      { nominal: 98, mass: 97.94214 },
      { nominal: 99, mass: 98.93411 },
      { nominal: 100, mass: 99.93096 },
      { nominal: 101, mass: 100.92634 },
      { nominal: 102, mass: 101.9241071 },
      { nominal: 103, mass: 102.9198819 },
      { nominal: 104, mass: 103.9182145 },
      { nominal: 105, mass: 104.914502 },
      { nominal: 106, mass: 105.913464 },
      { nominal: 107, mass: 106.91029 },
      { nominal: 108, mass: 107.9096935 },
      { nominal: 109, mass: 108.9071514 },
      { nominal: 110, mass: 109.90717 },
      { nominal: 111, mass: 110.9051085 },
      { nominal: 112, mass: 111.9055377 },
      { nominal: 113, mass: 112.90406184, abundance: 0.0429 },
      { nominal: 114, mass: 113.90491791 },
      { nominal: 115, mass: 114.903878776, abundance: 0.9571 },
      { nominal: 116, mass: 115.90525999 },
      { nominal: 117, mass: 116.9045157 },
      { nominal: 118, mass: 117.9063566 },
      { nominal: 119, mass: 118.9058507 },
      { nominal: 120, mass: 119.907967 },
      { nominal: 121, mass: 120.907851 },
      { nominal: 122, mass: 121.910281 },
      { nominal: 123, mass: 122.910434 },
      { nominal: 124, mass: 123.913182 },
      { nominal: 125, mass: 124.913605 },
      { nominal: 126, mass: 125.916507 },
      { nominal: 127, mass: 126.917446 },
      { nominal: 128, mass: 127.9204 },
      { nominal: 129, mass: 128.9218053 },
      { nominal: 130, mass: 129.924977 },
      { nominal: 131, mass: 130.9269715 },
      { nominal: 132, mass: 131.933001 },
      { nominal: 133, mass: 132.93831 },
      { nominal: 134, mass: 133.94454 },
      { nominal: 135, mass: 134.95005 },
    ],
    symbol: 'In',
    mass: 114.81808662944559,
    name: 'Indium',
    monoisotopicMass: 114.903878776,
  },
  {
    number: 50,
    isotopes: [
      { nominal: 99, mass: 98.94853 },
      { nominal: 100, mass: 99.9385 },
      { nominal: 101, mass: 100.93526 },
      { nominal: 102, mass: 101.93029 },
      { nominal: 103, mass: 102.928105 },
      { nominal: 104, mass: 103.9231052 },
      { nominal: 105, mass: 104.9212684 },
      { nominal: 106, mass: 105.9169574 },
      { nominal: 107, mass: 106.9157137 },
      { nominal: 108, mass: 107.9118943 },
      { nominal: 109, mass: 108.9112921 },
      { nominal: 110, mass: 109.907845 },
      { nominal: 111, mass: 110.9077401 },
      { nominal: 112, mass: 111.90482387, abundance: 0.0097 },
      { nominal: 113, mass: 112.9051757 },
      { nominal: 114, mass: 113.9027827, abundance: 0.0066 },
      { nominal: 115, mass: 114.903344699, abundance: 0.0034 },
      { nominal: 116, mass: 115.9017428, abundance: 0.1454 },
      { nominal: 117, mass: 116.90295398, abundance: 0.0768 },
      { nominal: 118, mass: 117.90160657, abundance: 0.2422 },
      { nominal: 119, mass: 118.90331117, abundance: 0.0859 },
      { nominal: 120, mass: 119.90220163, abundance: 0.3258 },
      { nominal: 121, mass: 120.9042426 },
      { nominal: 122, mass: 121.9034438, abundance: 0.0463 },
      { nominal: 123, mass: 122.9057252 },
      { nominal: 124, mass: 123.9052766, abundance: 0.0579 },
      { nominal: 125, mass: 124.9077864 },
      { nominal: 126, mass: 125.907659 },
      { nominal: 127, mass: 126.91039 },
      { nominal: 128, mass: 127.910507 },
      { nominal: 129, mass: 128.913465 },
      { nominal: 130, mass: 129.9139738 },
      { nominal: 131, mass: 130.917045 },
      { nominal: 132, mass: 131.9178267 },
      { nominal: 133, mass: 132.9239134 },
      { nominal: 134, mass: 133.9286821 },
      { nominal: 135, mass: 134.9349086 },
      { nominal: 136, mass: 135.93999 },
      { nominal: 137, mass: 136.94655 },
      { nominal: 138, mass: 137.95184 },
    ],
    symbol: 'Sn',
    mass: 118.71011259301059,
    name: 'Tin',
    monoisotopicMass: 119.90220163,
  },
  {
    number: 51,
    isotopes: [
      { nominal: 103, mass: 102.93969 },
      { nominal: 104, mass: 103.93648 },
      { nominal: 105, mass: 104.931276 },
      { nominal: 106, mass: 105.928638 },
      { nominal: 107, mass: 106.9241506 },
      { nominal: 108, mass: 107.9222267 },
      { nominal: 109, mass: 108.9181411 },
      { nominal: 110, mass: 109.9168543 },
      { nominal: 111, mass: 110.9132182 },
      { nominal: 112, mass: 111.9124 },
      { nominal: 113, mass: 112.909375 },
      { nominal: 114, mass: 113.90929 },
      { nominal: 115, mass: 114.906598 },
      { nominal: 116, mass: 115.9067931 },
      { nominal: 117, mass: 116.9048415 },
      { nominal: 118, mass: 117.9055321 },
      { nominal: 119, mass: 118.9039455 },
      { nominal: 120, mass: 119.9050794 },
      { nominal: 121, mass: 120.903812, abundance: 0.5721 },
      { nominal: 122, mass: 121.9051699 },
      { nominal: 123, mass: 122.9042132, abundance: 0.4279 },
      { nominal: 124, mass: 123.905935 },
      { nominal: 125, mass: 124.905253 },
      { nominal: 126, mass: 125.907253 },
      { nominal: 127, mass: 126.9069243 },
      { nominal: 128, mass: 127.909146 },
      { nominal: 129, mass: 128.909147 },
      { nominal: 130, mass: 129.911662 },
      { nominal: 131, mass: 130.9119888 },
      { nominal: 132, mass: 131.9145077 },
      { nominal: 133, mass: 132.9152732 },
      { nominal: 134, mass: 133.9205357 },
      { nominal: 135, mass: 134.9251851 },
      { nominal: 136, mass: 135.9307459 },
      { nominal: 137, mass: 136.93555 },
      { nominal: 138, mass: 137.94145 },
      { nominal: 139, mass: 138.94655 },
      { nominal: 140, mass: 139.95283 },
    ],
    symbol: 'Sb',
    mass: 121.75978367348,
    name: 'Antimony',
    monoisotopicMass: 120.903812,
  },
  {
    number: 52,
    isotopes: [
      { nominal: 105, mass: 104.9433 },
      { nominal: 106, mass: 105.9375 },
      { nominal: 107, mass: 106.935012 },
      { nominal: 108, mass: 107.9293805 },
      { nominal: 109, mass: 108.9273045 },
      { nominal: 110, mass: 109.9224581 },
      { nominal: 111, mass: 110.9210006 },
      { nominal: 112, mass: 111.9167279 },
      { nominal: 113, mass: 112.915891 },
      { nominal: 114, mass: 113.912089 },
      { nominal: 115, mass: 114.911902 },
      { nominal: 116, mass: 115.90846 },
      { nominal: 117, mass: 116.908646 },
      { nominal: 118, mass: 117.905854 },
      { nominal: 119, mass: 118.9064071 },
      { nominal: 120, mass: 119.9040593, abundance: 0.0009 },
      { nominal: 121, mass: 120.904944 },
      { nominal: 122, mass: 121.9030435, abundance: 0.0255 },
      { nominal: 123, mass: 122.9042698, abundance: 0.0089 },
      { nominal: 124, mass: 123.9028171, abundance: 0.0474 },
      { nominal: 125, mass: 124.9044299, abundance: 0.0707 },
      { nominal: 126, mass: 125.9033109, abundance: 0.1884 },
      { nominal: 127, mass: 126.9052257 },
      { nominal: 128, mass: 127.90446128, abundance: 0.3174 },
      { nominal: 129, mass: 128.90659646 },
      { nominal: 130, mass: 129.906222748, abundance: 0.3408 },
      { nominal: 131, mass: 130.908522213 },
      { nominal: 132, mass: 131.9085467 },
      { nominal: 133, mass: 132.9109688 },
      { nominal: 134, mass: 133.911394 },
      { nominal: 135, mass: 134.9165557 },
      { nominal: 136, mass: 135.9201006 },
      { nominal: 137, mass: 136.9255989 },
      { nominal: 138, mass: 137.9294722 },
      { nominal: 139, mass: 138.9353672 },
      { nominal: 140, mass: 139.939499 },
      { nominal: 141, mass: 140.9458 },
      { nominal: 142, mass: 141.95022 },
      { nominal: 143, mass: 142.95676 },
    ],
    symbol: 'Te',
    mass: 127.6031264846604,
    name: 'Tellurium',
    monoisotopicMass: 129.906222748,
  },
  {
    number: 53,
    isotopes: [
      { nominal: 107, mass: 106.94678 },
      { nominal: 108, mass: 107.94348 },
      { nominal: 109, mass: 108.9380853 },
      { nominal: 110, mass: 109.935089 },
      { nominal: 111, mass: 110.9302692 },
      { nominal: 112, mass: 111.928005 },
      { nominal: 113, mass: 112.9236501 },
      { nominal: 114, mass: 113.92185 },
      { nominal: 115, mass: 114.918048 },
      { nominal: 116, mass: 115.91681 },
      { nominal: 117, mass: 116.913648 },
      { nominal: 118, mass: 117.913074 },
      { nominal: 119, mass: 118.910074 },
      { nominal: 120, mass: 119.910087 },
      { nominal: 121, mass: 120.9074051 },
      { nominal: 122, mass: 121.9075888 },
      { nominal: 123, mass: 122.9055885 },
      { nominal: 124, mass: 123.906209 },
      { nominal: 125, mass: 124.9046294 },
      { nominal: 126, mass: 125.9056233 },
      { nominal: 127, mass: 126.9044719, abundance: 1 },
      { nominal: 128, mass: 127.9058086 },
      { nominal: 129, mass: 128.9049837 },
      { nominal: 130, mass: 129.9066702 },
      { nominal: 131, mass: 130.9061263 },
      { nominal: 132, mass: 131.9079935 },
      { nominal: 133, mass: 132.907797 },
      { nominal: 134, mass: 133.9097588 },
      { nominal: 135, mass: 134.9100488 },
      { nominal: 136, mass: 135.914604 },
      { nominal: 137, mass: 136.9180282 },
      { nominal: 138, mass: 137.9227264 },
      { nominal: 139, mass: 138.926506 },
      { nominal: 140, mass: 139.93173 },
      { nominal: 141, mass: 140.93569 },
      { nominal: 142, mass: 141.9412 },
      { nominal: 143, mass: 142.94565 },
      { nominal: 144, mass: 143.95139 },
      { nominal: 145, mass: 144.95605 },
    ],
    symbol: 'I',
    mass: 126.9044719,
    name: 'Iodine',
    monoisotopicMass: 126.9044719,
  },
  {
    number: 54,
    isotopes: [
      { nominal: 109, mass: 108.95043 },
      { nominal: 110, mass: 109.94426 },
      { nominal: 111, mass: 110.941607 },
      { nominal: 112, mass: 111.935559 },
      { nominal: 113, mass: 112.9332217 },
      { nominal: 114, mass: 113.92798 },
      { nominal: 115, mass: 114.926294 },
      { nominal: 116, mass: 115.921581 },
      { nominal: 117, mass: 116.920359 },
      { nominal: 118, mass: 117.916179 },
      { nominal: 119, mass: 118.915411 },
      { nominal: 120, mass: 119.911784 },
      { nominal: 121, mass: 120.911453 },
      { nominal: 122, mass: 121.908368 },
      { nominal: 123, mass: 122.908482 },
      { nominal: 124, mass: 123.905892, abundance: 0.000952 },
      { nominal: 125, mass: 124.9063944 },
      { nominal: 126, mass: 125.9042983, abundance: 0.00089 },
      { nominal: 127, mass: 126.9051829 },
      { nominal: 128, mass: 127.903531, abundance: 0.019102 },
      { nominal: 129, mass: 128.9047808611, abundance: 0.264006 },
      { nominal: 130, mass: 129.903509349, abundance: 0.04071 },
      { nominal: 131, mass: 130.90508406, abundance: 0.212324 },
      { nominal: 132, mass: 131.9041550856, abundance: 0.269086 },
      { nominal: 133, mass: 132.9059108 },
      { nominal: 134, mass: 133.90539466, abundance: 0.104357 },
      { nominal: 135, mass: 134.9072278 },
      { nominal: 136, mass: 135.907214484, abundance: 0.088573 },
      { nominal: 137, mass: 136.91155778 },
      { nominal: 138, mass: 137.9141463 },
      { nominal: 139, mass: 138.9187922 },
      { nominal: 140, mass: 139.9216458 },
      { nominal: 141, mass: 140.9267872 },
      { nominal: 142, mass: 141.9299731 },
      { nominal: 143, mass: 142.9353696 },
      { nominal: 144, mass: 143.9389451 },
      { nominal: 145, mass: 144.94472 },
      { nominal: 146, mass: 145.948518 },
      { nominal: 147, mass: 146.95426 },
      { nominal: 148, mass: 147.95813 },
    ],
    symbol: 'Xe',
    mass: 131.29276144779053,
    name: 'Xenon',
    monoisotopicMass: 131.9041550856,
  },
  {
    number: 55,
    isotopes: [
      { nominal: 112, mass: 111.950309 },
      { nominal: 113, mass: 112.9444291 },
      { nominal: 114, mass: 113.941296 },
      { nominal: 115, mass: 114.93591 },
      { nominal: 116, mass: 115.93337 },
      { nominal: 117, mass: 116.928617 },
      { nominal: 118, mass: 117.92656 },
      { nominal: 119, mass: 118.922377 },
      { nominal: 120, mass: 119.920677 },
      { nominal: 121, mass: 120.917227 },
      { nominal: 122, mass: 121.916108 },
      { nominal: 123, mass: 122.912996 },
      { nominal: 124, mass: 123.9122578 },
      { nominal: 125, mass: 124.909728 },
      { nominal: 126, mass: 125.909446 },
      { nominal: 127, mass: 126.9074174 },
      { nominal: 128, mass: 127.9077487 },
      { nominal: 129, mass: 128.9060657 },
      { nominal: 130, mass: 129.9067093 },
      { nominal: 131, mass: 130.9054649 },
      { nominal: 132, mass: 131.9064339 },
      { nominal: 133, mass: 132.905451961, abundance: 1 },
      { nominal: 134, mass: 133.906718503 },
      { nominal: 135, mass: 134.905977 },
      { nominal: 136, mass: 135.9073114 },
      { nominal: 137, mass: 136.90708923 },
      { nominal: 138, mass: 137.9110171 },
      { nominal: 139, mass: 138.9133638 },
      { nominal: 140, mass: 139.9172831 },
      { nominal: 141, mass: 140.9200455 },
      { nominal: 142, mass: 141.924296 },
      { nominal: 143, mass: 142.927349 },
      { nominal: 144, mass: 143.932076 },
      { nominal: 145, mass: 144.935527 },
      { nominal: 146, mass: 145.940344 },
      { nominal: 147, mass: 146.944156 },
      { nominal: 148, mass: 147.94923 },
      { nominal: 149, mass: 148.95302 },
      { nominal: 150, mass: 149.95833 },
      { nominal: 151, mass: 150.96258 },
    ],
    symbol: 'Cs',
    mass: 132.905451961,
    name: 'Caesium',
    monoisotopicMass: 132.905451961,
  },
  {
    number: 56,
    isotopes: [
      { nominal: 114, mass: 113.95066 },
      { nominal: 115, mass: 114.94737 },
      { nominal: 116, mass: 115.94128 },
      { nominal: 117, mass: 116.93814 },
      { nominal: 118, mass: 117.93306 },
      { nominal: 119, mass: 118.93066 },
      { nominal: 120, mass: 119.92605 },
      { nominal: 121, mass: 120.92405 },
      { nominal: 122, mass: 121.919904 },
      { nominal: 123, mass: 122.918781 },
      { nominal: 124, mass: 123.915094 },
      { nominal: 125, mass: 124.914472 },
      { nominal: 126, mass: 125.91125 },
      { nominal: 127, mass: 126.911091 },
      { nominal: 128, mass: 127.908342 },
      { nominal: 129, mass: 128.908681 },
      { nominal: 130, mass: 129.9063207, abundance: 0.00106 },
      { nominal: 131, mass: 130.906941 },
      { nominal: 132, mass: 131.9050611, abundance: 0.00101 },
      { nominal: 133, mass: 132.9060074 },
      { nominal: 134, mass: 133.90450818, abundance: 0.02417 },
      { nominal: 135, mass: 134.90568838, abundance: 0.06592 },
      { nominal: 136, mass: 135.90457573, abundance: 0.07854 },
      { nominal: 137, mass: 136.90582714, abundance: 0.11232 },
      { nominal: 138, mass: 137.905247, abundance: 0.71698 },
      { nominal: 139, mass: 138.9088411 },
      { nominal: 140, mass: 139.9106057 },
      { nominal: 141, mass: 140.9144033 },
      { nominal: 142, mass: 141.9164324 },
      { nominal: 143, mass: 142.9206253 },
      { nominal: 144, mass: 143.9229549 },
      { nominal: 145, mass: 144.9275184 },
      { nominal: 146, mass: 145.930284 },
      { nominal: 147, mass: 146.935304 },
      { nominal: 148, mass: 147.938171 },
      { nominal: 149, mass: 148.94308 },
      { nominal: 150, mass: 149.94605 },
      { nominal: 151, mass: 150.95127 },
      { nominal: 152, mass: 151.95481 },
      { nominal: 153, mass: 152.96036 },
    ],
    symbol: 'Ba',
    mass: 137.3268916286322,
    name: 'Barium',
    monoisotopicMass: 137.905247,
  },
  {
    number: 57,
    isotopes: [
      { nominal: 116, mass: 115.9563 },
      { nominal: 117, mass: 116.94999 },
      { nominal: 118, mass: 117.94673 },
      { nominal: 119, mass: 118.94099 },
      { nominal: 120, mass: 119.93807 },
      { nominal: 121, mass: 120.93315 },
      { nominal: 122, mass: 121.93071 },
      { nominal: 123, mass: 122.9263 },
      { nominal: 124, mass: 123.924574 },
      { nominal: 125, mass: 124.920816 },
      { nominal: 126, mass: 125.919513 },
      { nominal: 127, mass: 126.916375 },
      { nominal: 128, mass: 127.915592 },
      { nominal: 129, mass: 128.912694 },
      { nominal: 130, mass: 129.912369 },
      { nominal: 131, mass: 130.91007 },
      { nominal: 132, mass: 131.910119 },
      { nominal: 133, mass: 132.908218 },
      { nominal: 134, mass: 133.908514 },
      { nominal: 135, mass: 134.906984 },
      { nominal: 136, mass: 135.907635 },
      { nominal: 137, mass: 136.9064504 },
      { nominal: 138, mass: 137.9071149, abundance: 0.0008881 },
      { nominal: 139, mass: 138.9063563, abundance: 0.9991119 },
      { nominal: 140, mass: 139.9094806 },
      { nominal: 141, mass: 140.910966 },
      { nominal: 142, mass: 141.9140909 },
      { nominal: 143, mass: 142.9160795 },
      { nominal: 144, mass: 143.919646 },
      { nominal: 145, mass: 144.921808 },
      { nominal: 146, mass: 145.925875 },
      { nominal: 147, mass: 146.928418 },
      { nominal: 148, mass: 147.932679 },
      { nominal: 149, mass: 148.93535 },
      { nominal: 150, mass: 149.93947 },
      { nominal: 151, mass: 150.94232 },
      { nominal: 152, mass: 151.94682 },
      { nominal: 153, mass: 152.95036 },
      { nominal: 154, mass: 153.95517 },
      { nominal: 155, mass: 154.95901 },
    ],
    symbol: 'La',
    mass: 138.90546887371266,
    name: 'Lanthanum',
    monoisotopicMass: 138.9063563,
  },
  {
    number: 58,
    isotopes: [
      { nominal: 119, mass: 118.95271 },
      { nominal: 120, mass: 119.94654 },
      { nominal: 121, mass: 120.94335 },
      { nominal: 122, mass: 121.93787 },
      { nominal: 123, mass: 122.93528 },
      { nominal: 124, mass: 123.93031 },
      { nominal: 125, mass: 124.92844 },
      { nominal: 126, mass: 125.923971 },
      { nominal: 127, mass: 126.922727 },
      { nominal: 128, mass: 127.918911 },
      { nominal: 129, mass: 128.918102 },
      { nominal: 130, mass: 129.914736 },
      { nominal: 131, mass: 130.914429 },
      { nominal: 132, mass: 131.911464 },
      { nominal: 133, mass: 132.91152 },
      { nominal: 134, mass: 133.908928 },
      { nominal: 135, mass: 134.909161 },
      { nominal: 136, mass: 135.90712921, abundance: 0.00185 },
      { nominal: 137, mass: 136.90776236 },
      { nominal: 138, mass: 137.905991, abundance: 0.00251 },
      { nominal: 139, mass: 138.9066551 },
      { nominal: 140, mass: 139.9054431, abundance: 0.8845 },
      { nominal: 141, mass: 140.9082807 },
      { nominal: 142, mass: 141.9092504, abundance: 0.11114 },
      { nominal: 143, mass: 142.9123921 },
      { nominal: 144, mass: 143.9136529 },
      { nominal: 145, mass: 144.917265 },
      { nominal: 146, mass: 145.918802 },
      { nominal: 147, mass: 146.9226899 },
      { nominal: 148, mass: 147.924424 },
      { nominal: 149, mass: 148.928427 },
      { nominal: 150, mass: 149.930384 },
      { nominal: 151, mass: 150.934272 },
      { nominal: 152, mass: 151.9366 },
      { nominal: 153, mass: 152.94093 },
      { nominal: 154, mass: 153.9438 },
      { nominal: 155, mass: 154.94855 },
      { nominal: 156, mass: 155.95183 },
      { nominal: 157, mass: 156.95705 },
    ],
    symbol: 'Ce',
    mass: 140.1157307378545,
    name: 'Cerium',
    monoisotopicMass: 139.9054431,
  },
  {
    number: 59,
    isotopes: [
      { nominal: 121, mass: 120.95532 },
      { nominal: 122, mass: 121.95175 },
      { nominal: 123, mass: 122.94596 },
      { nominal: 124, mass: 123.94294 },
      { nominal: 125, mass: 124.9377 },
      { nominal: 126, mass: 125.93524 },
      { nominal: 127, mass: 126.93071 },
      { nominal: 128, mass: 127.928791 },
      { nominal: 129, mass: 128.925095 },
      { nominal: 130, mass: 129.92359 },
      { nominal: 131, mass: 130.920235 },
      { nominal: 132, mass: 131.919255 },
      { nominal: 133, mass: 132.916331 },
      { nominal: 134, mass: 133.915697 },
      { nominal: 135, mass: 134.913112 },
      { nominal: 136, mass: 135.912677 },
      { nominal: 137, mass: 136.9106792 },
      { nominal: 138, mass: 137.910754 },
      { nominal: 139, mass: 138.9089408 },
      { nominal: 140, mass: 139.9090803 },
      { nominal: 141, mass: 140.9076576, abundance: 1 },
      { nominal: 142, mass: 141.9100496 },
      { nominal: 143, mass: 142.9108228 },
      { nominal: 144, mass: 143.9133109 },
      { nominal: 145, mass: 144.9145182 },
      { nominal: 146, mass: 145.91768 },
      { nominal: 147, mass: 146.919008 },
      { nominal: 148, mass: 147.92213 },
      { nominal: 149, mass: 148.923736 },
      { nominal: 150, mass: 149.9266765 },
      { nominal: 151, mass: 150.928309 },
      { nominal: 152, mass: 151.931553 },
      { nominal: 153, mass: 152.933904 },
      { nominal: 154, mass: 153.93753 },
      { nominal: 155, mass: 154.940509 },
      { nominal: 156, mass: 155.94464 },
      { nominal: 157, mass: 156.94789 },
      { nominal: 158, mass: 157.95241 },
      { nominal: 159, mass: 158.95589 },
    ],
    symbol: 'Pr',
    mass: 140.9076576,
    name: 'Praseodymium',
    monoisotopicMass: 140.9076576,
  },
  {
    number: 60,
    isotopes: [
      { nominal: 124, mass: 123.9522 },
      { nominal: 125, mass: 124.9489 },
      { nominal: 126, mass: 125.94311 },
      { nominal: 127, mass: 126.94038 },
      { nominal: 128, mass: 127.93525 },
      { nominal: 129, mass: 128.9331 },
      { nominal: 130, mass: 129.928506 },
      { nominal: 131, mass: 130.927248 },
      { nominal: 132, mass: 131.923321 },
      { nominal: 133, mass: 132.922348 },
      { nominal: 134, mass: 133.91879 },
      { nominal: 135, mass: 134.918181 },
      { nominal: 136, mass: 135.914976 },
      { nominal: 137, mass: 136.914562 },
      { nominal: 138, mass: 137.91195 },
      { nominal: 139, mass: 138.911954 },
      { nominal: 140, mass: 139.90955 },
      { nominal: 141, mass: 140.9096147 },
      { nominal: 142, mass: 141.907729, abundance: 0.27152 },
      { nominal: 143, mass: 142.90982, abundance: 0.12174 },
      { nominal: 144, mass: 143.910093, abundance: 0.23798 },
      { nominal: 145, mass: 144.9125793, abundance: 0.08293 },
      { nominal: 146, mass: 145.9131226, abundance: 0.17189 },
      { nominal: 147, mass: 146.9161061 },
      { nominal: 148, mass: 147.9168993, abundance: 0.05756 },
      { nominal: 149, mass: 148.9201548 },
      { nominal: 150, mass: 149.9209022, abundance: 0.05638 },
      { nominal: 151, mass: 150.9238403 },
      { nominal: 152, mass: 151.924692 },
      { nominal: 153, mass: 152.927718 },
      { nominal: 154, mass: 153.92948 },
      { nominal: 155, mass: 154.9331357 },
      { nominal: 156, mass: 155.93508 },
      { nominal: 157, mass: 156.939386 },
      { nominal: 158, mass: 157.94197 },
      { nominal: 159, mass: 158.94653 },
      { nominal: 160, mass: 159.9494 },
      { nominal: 161, mass: 160.95428 },
    ],
    symbol: 'Nd',
    mass: 144.241596031827,
    name: 'Neodymium',
    monoisotopicMass: 141.907729,
  },
  {
    number: 61,
    isotopes: [
      { nominal: 126, mass: 125.95792 },
      { nominal: 127, mass: 126.95192 },
      { nominal: 128, mass: 127.9487 },
      { nominal: 129, mass: 128.94323 },
      { nominal: 130, mass: 129.94053 },
      { nominal: 131, mass: 130.93567 },
      { nominal: 132, mass: 131.93384 },
      { nominal: 133, mass: 132.929782 },
      { nominal: 134, mass: 133.928353 },
      { nominal: 135, mass: 134.924823 },
      { nominal: 136, mass: 135.923585 },
      { nominal: 137, mass: 136.92048 },
      { nominal: 138, mass: 137.919548 },
      { nominal: 139, mass: 138.9168 },
      { nominal: 140, mass: 139.91604 },
      { nominal: 141, mass: 140.913555 },
      { nominal: 142, mass: 141.91289 },
      { nominal: 143, mass: 142.9109383 },
      { nominal: 144, mass: 143.9125964 },
      { nominal: 145, mass: 144.9127559 },
      { nominal: 146, mass: 145.9147024 },
      { nominal: 147, mass: 146.915145 },
      { nominal: 148, mass: 147.9174819 },
      { nominal: 149, mass: 148.9183423 },
      { nominal: 150, mass: 149.920991 },
      { nominal: 151, mass: 150.9212175 },
      { nominal: 152, mass: 151.923506 },
      { nominal: 153, mass: 152.9241567 },
      { nominal: 154, mass: 153.926472 },
      { nominal: 155, mass: 154.928137 },
      { nominal: 156, mass: 155.9311175 },
      { nominal: 157, mass: 156.9331214 },
      { nominal: 158, mass: 157.936565 },
      { nominal: 159, mass: 158.939287 },
      { nominal: 160, mass: 159.9431 },
      { nominal: 161, mass: 160.94607 },
      { nominal: 162, mass: 161.95022 },
      { nominal: 163, mass: 162.95357 },
    ],
    symbol: 'Pm',
    mass: null,
    name: 'Promethium',
  },
  {
    number: 62,
    isotopes: [
      { nominal: 128, mass: 127.95842 },
      { nominal: 129, mass: 128.95476 },
      { nominal: 130, mass: 129.949 },
      { nominal: 131, mass: 130.94618 },
      { nominal: 132, mass: 131.94087 },
      { nominal: 133, mass: 132.93856 },
      { nominal: 134, mass: 133.93411 },
      { nominal: 135, mass: 134.93252 },
      { nominal: 136, mass: 135.928276 },
      { nominal: 137, mass: 136.926971 },
      { nominal: 138, mass: 137.923244 },
      { nominal: 139, mass: 138.922297 },
      { nominal: 140, mass: 139.918995 },
      { nominal: 141, mass: 140.9184816 },
      { nominal: 142, mass: 141.9152044 },
      { nominal: 143, mass: 142.9146353 },
      { nominal: 144, mass: 143.9120065, abundance: 0.0307 },
      { nominal: 145, mass: 144.9134173 },
      { nominal: 146, mass: 145.913047 },
      { nominal: 147, mass: 146.9149044, abundance: 0.1499 },
      { nominal: 148, mass: 147.9148292, abundance: 0.1124 },
      { nominal: 149, mass: 148.9171921, abundance: 0.1382 },
      { nominal: 150, mass: 149.9172829, abundance: 0.0738 },
      { nominal: 151, mass: 150.9199398 },
      { nominal: 152, mass: 151.9197397, abundance: 0.2675 },
      { nominal: 153, mass: 152.9221047 },
      { nominal: 154, mass: 153.9222169, abundance: 0.2275 },
      { nominal: 155, mass: 154.9246477 },
      { nominal: 156, mass: 155.925536 },
      { nominal: 157, mass: 156.9284187 },
      { nominal: 158, mass: 157.929951 },
      { nominal: 159, mass: 158.9332172 },
      { nominal: 160, mass: 159.9353353 },
      { nominal: 161, mass: 160.9391602 },
      { nominal: 162, mass: 161.94146 },
      { nominal: 163, mass: 162.94555 },
      { nominal: 164, mass: 163.94836 },
      { nominal: 165, mass: 164.95297 },
    ],
    symbol: 'Sm',
    mass: 150.36635571193,
    name: 'Samarium',
    monoisotopicMass: 151.9197397,
  },
  {
    number: 63,
    isotopes: [
      { nominal: 130, mass: 129.96369 },
      { nominal: 131, mass: 130.95784 },
      { nominal: 132, mass: 131.95467 },
      { nominal: 133, mass: 132.94929 },
      { nominal: 134, mass: 133.9464 },
      { nominal: 135, mass: 134.94187 },
      { nominal: 136, mass: 135.93962 },
      { nominal: 137, mass: 136.93546 },
      { nominal: 138, mass: 137.933709 },
      { nominal: 139, mass: 138.929792 },
      { nominal: 140, mass: 139.928088 },
      { nominal: 141, mass: 140.924932 },
      { nominal: 142, mass: 141.923442 },
      { nominal: 143, mass: 142.920299 },
      { nominal: 144, mass: 143.91882 },
      { nominal: 145, mass: 144.9162726 },
      { nominal: 146, mass: 145.917211 },
      { nominal: 147, mass: 146.9167527 },
      { nominal: 148, mass: 147.918089 },
      { nominal: 149, mass: 148.9179378 },
      { nominal: 150, mass: 149.9197077 },
      { nominal: 151, mass: 150.9198578, abundance: 0.4781 },
      { nominal: 152, mass: 151.9217522 },
      { nominal: 153, mass: 152.921238, abundance: 0.5219 },
      { nominal: 154, mass: 153.922987 },
      { nominal: 155, mass: 154.9229011 },
      { nominal: 156, mass: 155.9247605 },
      { nominal: 157, mass: 156.9254334 },
      { nominal: 158, mass: 157.927799 },
      { nominal: 159, mass: 158.9291001 },
      { nominal: 160, mass: 159.931851 },
      { nominal: 161, mass: 160.933664 },
      { nominal: 162, mass: 161.936989 },
      { nominal: 163, mass: 162.939196 },
      { nominal: 164, mass: 163.94274 },
      { nominal: 165, mass: 164.94559 },
      { nominal: 166, mass: 165.94962 },
      { nominal: 167, mass: 166.95289 },
    ],
    symbol: 'Eu',
    mass: 151.96437812637998,
    name: 'Europium',
    monoisotopicMass: 152.921238,
  },
  {
    number: 64,
    isotopes: [
      { nominal: 133, mass: 132.96133 },
      { nominal: 134, mass: 133.95566 },
      { nominal: 135, mass: 134.95245 },
      { nominal: 136, mass: 135.9473 },
      { nominal: 137, mass: 136.94502 },
      { nominal: 138, mass: 137.94025 },
      { nominal: 139, mass: 138.93813 },
      { nominal: 140, mass: 139.933674 },
      { nominal: 141, mass: 140.932126 },
      { nominal: 142, mass: 141.928116 },
      { nominal: 143, mass: 142.92675 },
      { nominal: 144, mass: 143.922963 },
      { nominal: 145, mass: 144.921713 },
      { nominal: 146, mass: 145.9183188 },
      { nominal: 147, mass: 146.9191014 },
      { nominal: 148, mass: 147.9181215 },
      { nominal: 149, mass: 148.9193481 },
      { nominal: 150, mass: 149.9186644 },
      { nominal: 151, mass: 150.920356 },
      { nominal: 152, mass: 151.9197995, abundance: 0.002 },
      { nominal: 153, mass: 152.921758 },
      { nominal: 154, mass: 153.9208741, abundance: 0.0218 },
      { nominal: 155, mass: 154.9226305, abundance: 0.148 },
      { nominal: 156, mass: 155.9221312, abundance: 0.2047 },
      { nominal: 157, mass: 156.9239686, abundance: 0.1565 },
      { nominal: 158, mass: 157.9241123, abundance: 0.2484 },
      { nominal: 159, mass: 158.926397 },
      { nominal: 160, mass: 159.9270624, abundance: 0.2186 },
      { nominal: 161, mass: 160.9296775 },
      { nominal: 162, mass: 161.930993 },
      { nominal: 163, mass: 162.9341769 },
      { nominal: 164, mass: 163.93583 },
      { nominal: 165, mass: 164.93936 },
      { nominal: 166, mass: 165.94146 },
      { nominal: 167, mass: 166.94545 },
      { nominal: 168, mass: 167.94808 },
      { nominal: 169, mass: 168.9526 },
    ],
    symbol: 'Gd',
    mass: 157.25213064687998,
    name: 'Gadolinium',
    monoisotopicMass: 157.9241123,
  },
  {
    number: 65,
    isotopes: [
      { nominal: 135, mass: 134.96476 },
      { nominal: 136, mass: 135.96129 },
      { nominal: 137, mass: 136.95602 },
      { nominal: 138, mass: 137.95312 },
      { nominal: 139, mass: 138.94833 },
      { nominal: 140, mass: 139.94581 },
      { nominal: 141, mass: 140.94145 },
      { nominal: 142, mass: 141.93928 },
      { nominal: 143, mass: 142.935137 },
      { nominal: 144, mass: 143.933045 },
      { nominal: 145, mass: 144.92882 },
      { nominal: 146, mass: 145.927253 },
      { nominal: 147, mass: 146.9240548 },
      { nominal: 148, mass: 147.924282 },
      { nominal: 149, mass: 148.9232535 },
      { nominal: 150, mass: 149.9236649 },
      { nominal: 151, mass: 150.9231096 },
      { nominal: 152, mass: 151.924083 },
      { nominal: 153, mass: 152.9234424 },
      { nominal: 154, mass: 153.924685 },
      { nominal: 155, mass: 154.923511 },
      { nominal: 156, mass: 155.9247552 },
      { nominal: 157, mass: 156.924033 },
      { nominal: 158, mass: 157.9254209 },
      { nominal: 159, mass: 158.9253547, abundance: 1 },
      { nominal: 160, mass: 159.9271756 },
      { nominal: 161, mass: 160.9275778 },
      { nominal: 162, mass: 161.929495 },
      { nominal: 163, mass: 162.9306547 },
      { nominal: 164, mass: 163.93336 },
      { nominal: 165, mass: 164.93498 },
      { nominal: 166, mass: 165.93786 },
      { nominal: 167, mass: 166.93996 },
      { nominal: 168, mass: 167.9434 },
      { nominal: 169, mass: 168.94597 },
      { nominal: 170, mass: 169.94984 },
      { nominal: 171, mass: 170.95273 },
    ],
    symbol: 'Tb',
    mass: 158.9253547,
    name: 'Terbium',
    monoisotopicMass: 158.9253547,
  },
  {
    number: 66,
    isotopes: [
      { nominal: 138, mass: 137.9625 },
      { nominal: 139, mass: 138.95959 },
      { nominal: 140, mass: 139.95402 },
      { nominal: 141, mass: 140.95128 },
      { nominal: 142, mass: 141.94619 },
      { nominal: 143, mass: 142.943994 },
      { nominal: 144, mass: 143.9392695 },
      { nominal: 145, mass: 144.937474 },
      { nominal: 146, mass: 145.9328445 },
      { nominal: 147, mass: 146.9310827 },
      { nominal: 148, mass: 147.927157 },
      { nominal: 149, mass: 148.927322 },
      { nominal: 150, mass: 149.9255933 },
      { nominal: 151, mass: 150.9261916 },
      { nominal: 152, mass: 151.9247253 },
      { nominal: 153, mass: 152.9257724 },
      { nominal: 154, mass: 153.9244293 },
      { nominal: 155, mass: 154.925759 },
      { nominal: 156, mass: 155.9242847, abundance: 0.00056 },
      { nominal: 157, mass: 156.9254707 },
      { nominal: 158, mass: 157.9244159, abundance: 0.00095 },
      { nominal: 159, mass: 158.925747 },
      { nominal: 160, mass: 159.9252046, abundance: 0.02329 },
      { nominal: 161, mass: 160.9269405, abundance: 0.18889 },
      { nominal: 162, mass: 161.9268056, abundance: 0.25475 },
      { nominal: 163, mass: 162.9287383, abundance: 0.24896 },
      { nominal: 164, mass: 163.9291819, abundance: 0.2826 },
      { nominal: 165, mass: 164.9317105 },
      { nominal: 166, mass: 165.9328139 },
      { nominal: 167, mass: 166.935661 },
      { nominal: 168, mass: 167.93713 },
      { nominal: 169, mass: 168.94031 },
      { nominal: 170, mass: 169.94239 },
      { nominal: 171, mass: 170.94612 },
      { nominal: 172, mass: 171.94846 },
      { nominal: 173, mass: 172.95283 },
    ],
    symbol: 'Dy',
    mass: 162.499472819424,
    name: 'Dysprosium',
    monoisotopicMass: 163.9291819,
  },
  {
    number: 67,
    isotopes: [
      { nominal: 140, mass: 139.96859 },
      { nominal: 141, mass: 140.96311 },
      { nominal: 142, mass: 141.96001 },
      { nominal: 143, mass: 142.95486 },
      { nominal: 144, mass: 143.9521097 },
      { nominal: 145, mass: 144.9472674 },
      { nominal: 146, mass: 145.9449935 },
      { nominal: 147, mass: 146.9401423 },
      { nominal: 148, mass: 147.937744 },
      { nominal: 149, mass: 148.933803 },
      { nominal: 150, mass: 149.933498 },
      { nominal: 151, mass: 150.9316983 },
      { nominal: 152, mass: 151.931724 },
      { nominal: 153, mass: 152.9302064 },
      { nominal: 154, mass: 153.9306068 },
      { nominal: 155, mass: 154.929104 },
      { nominal: 156, mass: 155.929706 },
      { nominal: 157, mass: 156.928254 },
      { nominal: 158, mass: 157.928946 },
      { nominal: 159, mass: 158.9277197 },
      { nominal: 160, mass: 159.928737 },
      { nominal: 161, mass: 160.9278615 },
      { nominal: 162, mass: 161.9291023 },
      { nominal: 163, mass: 162.928741 },
      { nominal: 164, mass: 163.9302403 },
      { nominal: 165, mass: 164.9303288, abundance: 1 },
      { nominal: 166, mass: 165.9322909 },
      { nominal: 167, mass: 166.9331385 },
      { nominal: 168, mass: 167.935522 },
      { nominal: 169, mass: 168.936878 },
      { nominal: 170, mass: 169.939625 },
      { nominal: 171, mass: 170.94147 },
      { nominal: 172, mass: 171.94473 },
      { nominal: 173, mass: 172.94702 },
      { nominal: 174, mass: 173.95095 },
      { nominal: 175, mass: 174.95362 },
    ],
    symbol: 'Ho',
    mass: 164.9303288,
    name: 'Holmium',
    monoisotopicMass: 164.9303288,
  },
  {
    number: 68,
    isotopes: [
      { nominal: 142, mass: 141.9701 },
      { nominal: 143, mass: 142.96662 },
      { nominal: 144, mass: 143.9607 },
      { nominal: 145, mass: 144.95805 },
      { nominal: 146, mass: 145.9524184 },
      { nominal: 147, mass: 146.949964 },
      { nominal: 148, mass: 147.944735 },
      { nominal: 149, mass: 148.942306 },
      { nominal: 150, mass: 149.937916 },
      { nominal: 151, mass: 150.937449 },
      { nominal: 152, mass: 151.935057 },
      { nominal: 153, mass: 152.93508 },
      { nominal: 154, mass: 153.9327908 },
      { nominal: 155, mass: 154.9332159 },
      { nominal: 156, mass: 155.931067 },
      { nominal: 157, mass: 156.931949 },
      { nominal: 158, mass: 157.929893 },
      { nominal: 159, mass: 158.9306918 },
      { nominal: 160, mass: 159.929077 },
      { nominal: 161, mass: 160.9300046 },
      { nominal: 162, mass: 161.9287884, abundance: 0.00139 },
      { nominal: 163, mass: 162.9300408 },
      { nominal: 164, mass: 163.9292088, abundance: 0.01601 },
      { nominal: 165, mass: 164.9307345 },
      { nominal: 166, mass: 165.9302995, abundance: 0.33503 },
      { nominal: 167, mass: 166.9320546, abundance: 0.22869 },
      { nominal: 168, mass: 167.9323767, abundance: 0.26978 },
      { nominal: 169, mass: 168.9345968 },
      { nominal: 170, mass: 169.9354702, abundance: 0.1491 },
      { nominal: 171, mass: 170.9380357 },
      { nominal: 172, mass: 171.9393619 },
      { nominal: 173, mass: 172.9424 },
      { nominal: 174, mass: 173.94423 },
      { nominal: 175, mass: 174.94777 },
      { nominal: 176, mass: 175.94994 },
      { nominal: 177, mass: 176.95399 },
    ],
    symbol: 'Er',
    mass: 167.259082649669,
    name: 'Erbium',
    monoisotopicMass: 165.9302995,
  },
  {
    number: 69,
    isotopes: [
      { nominal: 144, mass: 143.97628 },
      { nominal: 145, mass: 144.97039 },
      { nominal: 146, mass: 145.96684 },
      { nominal: 147, mass: 146.9613799 },
      { nominal: 148, mass: 147.958384 },
      { nominal: 149, mass: 148.95289 },
      { nominal: 150, mass: 149.95009 },
      { nominal: 151, mass: 150.945488 },
      { nominal: 152, mass: 151.944422 },
      { nominal: 153, mass: 152.94204 },
      { nominal: 154, mass: 153.94157 },
      { nominal: 155, mass: 154.93921 },
      { nominal: 156, mass: 155.938992 },
      { nominal: 157, mass: 156.936944 },
      { nominal: 158, mass: 157.93698 },
      { nominal: 159, mass: 158.934975 },
      { nominal: 160, mass: 159.935263 },
      { nominal: 161, mass: 160.933549 },
      { nominal: 162, mass: 161.934002 },
      { nominal: 163, mass: 162.9326592 },
      { nominal: 164, mass: 163.933544 },
      { nominal: 165, mass: 164.9324431 },
      { nominal: 166, mass: 165.933561 },
      { nominal: 167, mass: 166.9328562 },
      { nominal: 168, mass: 167.9341774 },
      { nominal: 169, mass: 168.9342179, abundance: 1 },
      { nominal: 170, mass: 169.935806 },
      { nominal: 171, mass: 170.9364339 },
      { nominal: 172, mass: 171.9384055 },
      { nominal: 173, mass: 172.9396084 },
      { nominal: 174, mass: 173.942173 },
      { nominal: 175, mass: 174.943841 },
      { nominal: 176, mass: 175.947 },
      { nominal: 177, mass: 176.94904 },
      { nominal: 178, mass: 177.95264 },
      { nominal: 179, mass: 178.95534 },
    ],
    symbol: 'Tm',
    mass: 168.9342179,
    name: 'Thulium',
    monoisotopicMass: 168.9342179,
  },
  {
    number: 70,
    isotopes: [
      { nominal: 148, mass: 147.96758 },
      { nominal: 149, mass: 148.96436 },
      { nominal: 150, mass: 149.95852 },
      { nominal: 151, mass: 150.9554 },
      { nominal: 152, mass: 151.95027 },
      { nominal: 153, mass: 152.94932 },
      { nominal: 154, mass: 153.946396 },
      { nominal: 155, mass: 154.945783 },
      { nominal: 156, mass: 155.942825 },
      { nominal: 157, mass: 156.942645 },
      { nominal: 158, mass: 157.9398705 },
      { nominal: 159, mass: 158.940055 },
      { nominal: 160, mass: 159.937557 },
      { nominal: 161, mass: 160.937907 },
      { nominal: 162, mass: 161.935774 },
      { nominal: 163, mass: 162.93634 },
      { nominal: 164, mass: 163.934495 },
      { nominal: 165, mass: 164.93527 },
      { nominal: 166, mass: 165.9338747 },
      { nominal: 167, mass: 166.934953 },
      { nominal: 168, mass: 167.9338896, abundance: 0.00123 },
      { nominal: 169, mass: 168.9351825 },
      { nominal: 170, mass: 169.9347664, abundance: 0.02982 },
      { nominal: 171, mass: 170.9363302, abundance: 0.1409 },
      { nominal: 172, mass: 171.9363859, abundance: 0.2168 },
      { nominal: 173, mass: 172.9382151, abundance: 0.16103 },
      { nominal: 174, mass: 173.9388664, abundance: 0.32026 },
      { nominal: 175, mass: 174.9412808 },
      { nominal: 176, mass: 175.9425764, abundance: 0.12996 },
      { nominal: 177, mass: 176.9452656 },
      { nominal: 178, mass: 177.946651 },
      { nominal: 179, mass: 178.95004 },
      { nominal: 180, mass: 179.95212 },
      { nominal: 181, mass: 180.95589 },
    ],
    symbol: 'Yb',
    mass: 173.05415016631702,
    name: 'Ytterbium',
    monoisotopicMass: 173.9388664,
  },
  {
    number: 71,
    isotopes: [
      { nominal: 150, mass: 149.97355 },
      { nominal: 151, mass: 150.96768 },
      { nominal: 152, mass: 151.96412 },
      { nominal: 153, mass: 152.95875 },
      { nominal: 154, mass: 153.95736 },
      { nominal: 155, mass: 154.954321 },
      { nominal: 156, mass: 155.953033 },
      { nominal: 157, mass: 156.950127 },
      { nominal: 158, mass: 157.949316 },
      { nominal: 159, mass: 158.946636 },
      { nominal: 160, mass: 159.946033 },
      { nominal: 161, mass: 160.943572 },
      { nominal: 162, mass: 161.943283 },
      { nominal: 163, mass: 162.941179 },
      { nominal: 164, mass: 163.941339 },
      { nominal: 165, mass: 164.939407 },
      { nominal: 166, mass: 165.939859 },
      { nominal: 167, mass: 166.93827 },
      { nominal: 168, mass: 167.938736 },
      { nominal: 169, mass: 168.9376441 },
      { nominal: 170, mass: 169.938478 },
      { nominal: 171, mass: 170.937917 },
      { nominal: 172, mass: 171.9390891 },
      { nominal: 173, mass: 172.938934 },
      { nominal: 174, mass: 173.9403409 },
      { nominal: 175, mass: 174.9407752, abundance: 0.97401 },
      { nominal: 176, mass: 175.9426897, abundance: 0.02599 },
      { nominal: 177, mass: 176.9437615 },
      { nominal: 178, mass: 177.945958 },
      { nominal: 179, mass: 178.9473309 },
      { nominal: 180, mass: 179.949888 },
      { nominal: 181, mass: 180.95191 },
      { nominal: 182, mass: 181.95504 },
      { nominal: 183, mass: 182.957363 },
      { nominal: 184, mass: 183.96091 },
      { nominal: 185, mass: 184.96362 },
    ],
    symbol: 'Lu',
    mass: 174.96681495785498,
    name: 'Lutetium',
    monoisotopicMass: 174.9407752,
  },
  {
    number: 72,
    isotopes: [
      { nominal: 153, mass: 152.97069 },
      { nominal: 154, mass: 153.96486 },
      { nominal: 155, mass: 154.96311 },
      { nominal: 156, mass: 155.95935 },
      { nominal: 157, mass: 156.95824 },
      { nominal: 158, mass: 157.954801 },
      { nominal: 159, mass: 158.953996 },
      { nominal: 160, mass: 159.950691 },
      { nominal: 161, mass: 160.950278 },
      { nominal: 162, mass: 161.9472148 },
      { nominal: 163, mass: 162.947113 },
      { nominal: 164, mass: 163.944371 },
      { nominal: 165, mass: 164.944567 },
      { nominal: 166, mass: 165.94218 },
      { nominal: 167, mass: 166.9426 },
      { nominal: 168, mass: 167.940568 },
      { nominal: 169, mass: 168.941259 },
      { nominal: 170, mass: 169.939609 },
      { nominal: 171, mass: 170.940492 },
      { nominal: 172, mass: 171.93945 },
      { nominal: 173, mass: 172.940513 },
      { nominal: 174, mass: 173.9400461, abundance: 0.0016 },
      { nominal: 175, mass: 174.9415092 },
      { nominal: 176, mass: 175.9414076, abundance: 0.0526 },
      { nominal: 177, mass: 176.9432277, abundance: 0.186 },
      { nominal: 178, mass: 177.9437058, abundance: 0.2728 },
      { nominal: 179, mass: 178.9458232, abundance: 0.1362 },
      { nominal: 180, mass: 179.946557, abundance: 0.3508 },
      { nominal: 181, mass: 180.9491083 },
      { nominal: 182, mass: 181.9505612 },
      { nominal: 183, mass: 182.95353 },
      { nominal: 184, mass: 183.955446 },
      { nominal: 185, mass: 184.958862 },
      { nominal: 186, mass: 185.960897 },
      { nominal: 187, mass: 186.96477 },
      { nominal: 188, mass: 187.96685 },
      { nominal: 189, mass: 188.97084 },
    ],
    symbol: 'Hf',
    mass: 178.4849787234,
    name: 'Hafnium',
    monoisotopicMass: 179.946557,
  },
  {
    number: 73,
    isotopes: [
      { nominal: 155, mass: 154.97424 },
      { nominal: 156, mass: 155.97203 },
      { nominal: 157, mass: 156.96818 },
      { nominal: 158, mass: 157.96654 },
      { nominal: 159, mass: 158.963023 },
      { nominal: 160, mass: 159.961488 },
      { nominal: 161, mass: 160.958452 },
      { nominal: 162, mass: 161.957294 },
      { nominal: 163, mass: 162.954337 },
      { nominal: 164, mass: 163.953534 },
      { nominal: 165, mass: 164.950781 },
      { nominal: 166, mass: 165.950512 },
      { nominal: 167, mass: 166.948093 },
      { nominal: 168, mass: 167.948047 },
      { nominal: 169, mass: 168.946011 },
      { nominal: 170, mass: 169.946175 },
      { nominal: 171, mass: 170.944476 },
      { nominal: 172, mass: 171.944895 },
      { nominal: 173, mass: 172.94375 },
      { nominal: 174, mass: 173.944454 },
      { nominal: 175, mass: 174.943737 },
      { nominal: 176, mass: 175.944857 },
      { nominal: 177, mass: 176.9444795 },
      { nominal: 178, mass: 177.945678 },
      { nominal: 179, mass: 178.9459366 },
      { nominal: 180, mass: 179.9474648, abundance: 0.0001201 },
      { nominal: 181, mass: 180.9479958, abundance: 0.9998799 },
      { nominal: 182, mass: 181.9501519 },
      { nominal: 183, mass: 182.9513726 },
      { nominal: 184, mass: 183.954008 },
      { nominal: 185, mass: 184.955559 },
      { nominal: 186, mass: 185.958551 },
      { nominal: 187, mass: 186.960386 },
      { nominal: 188, mass: 187.963916 },
      { nominal: 189, mass: 188.96583 },
      { nominal: 190, mass: 189.96939 },
      { nominal: 191, mass: 190.97156 },
      { nominal: 192, mass: 191.97514 },
    ],
    symbol: 'Ta',
    mass: 180.9478756362269,
    name: 'Tantalum',
    monoisotopicMass: 180.9479958,
  },
  {
    number: 74,
    isotopes: [
      { nominal: 157, mass: 156.97884 },
      { nominal: 158, mass: 157.97456 },
      { nominal: 159, mass: 158.97264 },
      { nominal: 160, mass: 159.96846 },
      { nominal: 161, mass: 160.9672 },
      { nominal: 162, mass: 161.963499 },
      { nominal: 163, mass: 162.962524 },
      { nominal: 164, mass: 163.958961 },
      { nominal: 165, mass: 164.958281 },
      { nominal: 166, mass: 165.955031 },
      { nominal: 167, mass: 166.954805 },
      { nominal: 168, mass: 167.951806 },
      { nominal: 169, mass: 168.951779 },
      { nominal: 170, mass: 169.949232 },
      { nominal: 171, mass: 170.949451 },
      { nominal: 172, mass: 171.947292 },
      { nominal: 173, mass: 172.947689 },
      { nominal: 174, mass: 173.946079 },
      { nominal: 175, mass: 174.946717 },
      { nominal: 176, mass: 175.945634 },
      { nominal: 177, mass: 176.946643 },
      { nominal: 178, mass: 177.945883 },
      { nominal: 179, mass: 178.947077 },
      { nominal: 180, mass: 179.9467108, abundance: 0.0012 },
      { nominal: 181, mass: 180.9481978 },
      { nominal: 182, mass: 181.94820394, abundance: 0.265 },
      { nominal: 183, mass: 182.95022275, abundance: 0.1431 },
      { nominal: 184, mass: 183.95093092, abundance: 0.3064 },
      { nominal: 185, mass: 184.95341897 },
      { nominal: 186, mass: 185.9543628, abundance: 0.2843 },
      { nominal: 187, mass: 186.9571588 },
      { nominal: 188, mass: 187.9584862 },
      { nominal: 189, mass: 188.961763 },
      { nominal: 190, mass: 189.963091 },
      { nominal: 191, mass: 190.966531 },
      { nominal: 192, mass: 191.96817 },
      { nominal: 193, mass: 192.97178 },
      { nominal: 194, mass: 193.97367 },
    ],
    symbol: 'W',
    mass: 183.841777550513,
    name: 'Tungsten',
    monoisotopicMass: 183.95093092,
  },
  {
    number: 75,
    isotopes: [
      { nominal: 159, mass: 158.98418 },
      { nominal: 160, mass: 159.98182 },
      { nominal: 161, mass: 160.97757 },
      { nominal: 162, mass: 161.97584 },
      { nominal: 163, mass: 162.97208 },
      { nominal: 164, mass: 163.970453 },
      { nominal: 165, mass: 164.967103 },
      { nominal: 166, mass: 165.965761 },
      { nominal: 167, mass: 166.962595 },
      { nominal: 168, mass: 167.961573 },
      { nominal: 169, mass: 168.958766 },
      { nominal: 170, mass: 169.95822 },
      { nominal: 171, mass: 170.955716 },
      { nominal: 172, mass: 171.95542 },
      { nominal: 173, mass: 172.953243 },
      { nominal: 174, mass: 173.953115 },
      { nominal: 175, mass: 174.951381 },
      { nominal: 176, mass: 175.951623 },
      { nominal: 177, mass: 176.950328 },
      { nominal: 178, mass: 177.950989 },
      { nominal: 179, mass: 178.949989 },
      { nominal: 180, mass: 179.950792 },
      { nominal: 181, mass: 180.950058 },
      { nominal: 182, mass: 181.95121 },
      { nominal: 183, mass: 182.9508196 },
      { nominal: 184, mass: 183.9525228 },
      { nominal: 185, mass: 184.9529545, abundance: 0.374 },
      { nominal: 186, mass: 185.9549856 },
      { nominal: 187, mass: 186.9557501, abundance: 0.626 },
      { nominal: 188, mass: 187.9581115 },
      { nominal: 189, mass: 188.959226 },
      { nominal: 190, mass: 189.961744 },
      { nominal: 191, mass: 190.963122 },
      { nominal: 192, mass: 191.966088 },
      { nominal: 193, mass: 192.967541 },
      { nominal: 194, mass: 193.97076 },
      { nominal: 195, mass: 194.97254 },
      { nominal: 196, mass: 195.9758 },
      { nominal: 197, mass: 196.97799 },
      { nominal: 198, mass: 197.9816 },
    ],
    symbol: 'Re',
    mass: 186.20670454560002,
    name: 'Rhenium',
    monoisotopicMass: 186.9557501,
  },
  {
    number: 76,
    isotopes: [
      { nominal: 161, mass: 160.98903 },
      { nominal: 162, mass: 161.98443 },
      { nominal: 163, mass: 162.98241 },
      { nominal: 164, mass: 163.97802 },
      { nominal: 165, mass: 164.9766 },
      { nominal: 166, mass: 165.972692 },
      { nominal: 167, mass: 166.971549 },
      { nominal: 168, mass: 167.967808 },
      { nominal: 169, mass: 168.967018 },
      { nominal: 170, mass: 169.963578 },
      { nominal: 171, mass: 170.963174 },
      { nominal: 172, mass: 171.960017 },
      { nominal: 173, mass: 172.959808 },
      { nominal: 174, mass: 173.957064 },
      { nominal: 175, mass: 174.956945 },
      { nominal: 176, mass: 175.954806 },
      { nominal: 177, mass: 176.954966 },
      { nominal: 178, mass: 177.953254 },
      { nominal: 179, mass: 178.953817 },
      { nominal: 180, mass: 179.952375 },
      { nominal: 181, mass: 180.953247 },
      { nominal: 182, mass: 181.95211 },
      { nominal: 183, mass: 182.953125 },
      { nominal: 184, mass: 183.9524885, abundance: 0.0002 },
      { nominal: 185, mass: 184.9540417 },
      { nominal: 186, mass: 185.953835, abundance: 0.0159 },
      { nominal: 187, mass: 186.9557474, abundance: 0.0196 },
      { nominal: 188, mass: 187.9558352, abundance: 0.1324 },
      { nominal: 189, mass: 188.9581442, abundance: 0.1615 },
      { nominal: 190, mass: 189.9584437, abundance: 0.2626 },
      { nominal: 191, mass: 190.9609264 },
      { nominal: 192, mass: 191.961477, abundance: 0.4078 },
      { nominal: 193, mass: 192.9641479 },
      { nominal: 194, mass: 193.9651772 },
      { nominal: 195, mass: 194.968318 },
      { nominal: 196, mass: 195.969641 },
      { nominal: 197, mass: 196.97283 },
      { nominal: 198, mass: 197.97441 },
      { nominal: 199, mass: 198.97801 },
      { nominal: 200, mass: 199.97984 },
      { nominal: 201, mass: 200.98364 },
      { nominal: 202, mass: 201.98595 },
    ],
    symbol: 'Os',
    mass: 190.22485962823998,
    name: 'Osmium',
    monoisotopicMass: 191.961477,
  },
  {
    number: 77,
    isotopes: [
      { nominal: 164, mass: 163.99191 },
      { nominal: 165, mass: 164.9875 },
      { nominal: 166, mass: 165.98566 },
      { nominal: 167, mass: 166.981666 },
      { nominal: 168, mass: 167.979907 },
      { nominal: 169, mass: 168.976298 },
      { nominal: 170, mass: 169.974922 },
      { nominal: 171, mass: 170.97164 },
      { nominal: 172, mass: 171.970607 },
      { nominal: 173, mass: 172.967506 },
      { nominal: 174, mass: 173.966861 },
      { nominal: 175, mass: 174.96415 },
      { nominal: 176, mass: 175.96365 },
      { nominal: 177, mass: 176.961301 },
      { nominal: 178, mass: 177.961082 },
      { nominal: 179, mass: 178.95912 },
      { nominal: 180, mass: 179.959229 },
      { nominal: 181, mass: 180.957625 },
      { nominal: 182, mass: 181.958076 },
      { nominal: 183, mass: 182.95684 },
      { nominal: 184, mass: 183.957476 },
      { nominal: 185, mass: 184.956698 },
      { nominal: 186, mass: 185.957944 },
      { nominal: 187, mass: 186.957542 },
      { nominal: 188, mass: 187.958828 },
      { nominal: 189, mass: 188.958715 },
      { nominal: 190, mass: 189.9605412 },
      { nominal: 191, mass: 190.9605893, abundance: 0.373 },
      { nominal: 192, mass: 191.9626002 },
      { nominal: 193, mass: 192.9629216, abundance: 0.627 },
      { nominal: 194, mass: 193.9650735 },
      { nominal: 195, mass: 194.9659747 },
      { nominal: 196, mass: 195.968397 },
      { nominal: 197, mass: 196.969655 },
      { nominal: 198, mass: 197.97228 },
      { nominal: 199, mass: 198.973805 },
      { nominal: 200, mass: 199.9768 },
      { nominal: 201, mass: 200.97864 },
      { nominal: 202, mass: 201.98199 },
      { nominal: 203, mass: 202.98423 },
      { nominal: 204, mass: 203.9896 },
    ],
    symbol: 'Ir',
    mass: 192.2160516521,
    name: 'Iridium',
    monoisotopicMass: 192.9629216,
  },
  {
    number: 78,
    isotopes: [
      { nominal: 166, mass: 165.99486 },
      { nominal: 167, mass: 166.99269 },
      { nominal: 168, mass: 167.98813 },
      { nominal: 169, mass: 168.98657 },
      { nominal: 170, mass: 169.982496 },
      { nominal: 171, mass: 170.981245 },
      { nominal: 172, mass: 171.977351 },
      { nominal: 173, mass: 172.976443 },
      { nominal: 174, mass: 173.97282 },
      { nominal: 175, mass: 174.97241 },
      { nominal: 176, mass: 175.968938 },
      { nominal: 177, mass: 176.96847 },
      { nominal: 178, mass: 177.96565 },
      { nominal: 179, mass: 178.965359 },
      { nominal: 180, mass: 179.963032 },
      { nominal: 181, mass: 180.963098 },
      { nominal: 182, mass: 181.961172 },
      { nominal: 183, mass: 182.961597 },
      { nominal: 184, mass: 183.959915 },
      { nominal: 185, mass: 184.960614 },
      { nominal: 186, mass: 185.959351 },
      { nominal: 187, mass: 186.960617 },
      { nominal: 188, mass: 187.9593889 },
      { nominal: 189, mass: 188.960831 },
      { nominal: 190, mass: 189.9599297, abundance: 0.00012 },
      { nominal: 191, mass: 190.9616729 },
      { nominal: 192, mass: 191.9610387, abundance: 0.00782 },
      { nominal: 193, mass: 192.9629824 },
      { nominal: 194, mass: 193.9626809, abundance: 0.3286 },
      { nominal: 195, mass: 194.9647917, abundance: 0.3378 },
      { nominal: 196, mass: 195.96495209, abundance: 0.2521 },
      { nominal: 197, mass: 196.96734069 },
      { nominal: 198, mass: 197.9678949, abundance: 0.07356 },
      { nominal: 199, mass: 198.9705952 },
      { nominal: 200, mass: 199.971443 },
      { nominal: 201, mass: 200.974513 },
      { nominal: 202, mass: 201.975639 },
      { nominal: 203, mass: 202.97893 },
      { nominal: 204, mass: 203.98076 },
      { nominal: 205, mass: 204.98608 },
      { nominal: 206, mass: 205.98966 },
    ],
    symbol: 'Pt',
    mass: 195.084456864931,
    name: 'Platinum',
    monoisotopicMass: 194.9647917,
  },
  {
    number: 79,
    isotopes: [
      { nominal: 169, mass: 168.99808 },
      { nominal: 170, mass: 169.99597 },
      { nominal: 171, mass: 170.991876 },
      { nominal: 172, mass: 171.989942 },
      { nominal: 173, mass: 172.986241 },
      { nominal: 174, mass: 173.984717 },
      { nominal: 175, mass: 174.981304 },
      { nominal: 176, mass: 175.98025 },
      { nominal: 177, mass: 176.97687 },
      { nominal: 178, mass: 177.976032 },
      { nominal: 179, mass: 178.973174 },
      { nominal: 180, mass: 179.972523 },
      { nominal: 181, mass: 180.970079 },
      { nominal: 182, mass: 181.969618 },
      { nominal: 183, mass: 182.967591 },
      { nominal: 184, mass: 183.967452 },
      { nominal: 185, mass: 184.96579 },
      { nominal: 186, mass: 185.965953 },
      { nominal: 187, mass: 186.964543 },
      { nominal: 188, mass: 187.965349 },
      { nominal: 189, mass: 188.963948 },
      { nominal: 190, mass: 189.964698 },
      { nominal: 191, mass: 190.963702 },
      { nominal: 192, mass: 191.964814 },
      { nominal: 193, mass: 192.9641373 },
      { nominal: 194, mass: 193.9654178 },
      { nominal: 195, mass: 194.9650352 },
      { nominal: 196, mass: 195.9665699 },
      { nominal: 197, mass: 196.96656879, abundance: 1 },
      { nominal: 198, mass: 197.96824242 },
      { nominal: 199, mass: 198.96876528 },
      { nominal: 200, mass: 199.970756 },
      { nominal: 201, mass: 200.9716575 },
      { nominal: 202, mass: 201.973856 },
      { nominal: 203, mass: 202.9751544 },
      { nominal: 204, mass: 203.97783 },
      { nominal: 205, mass: 204.97985 },
      { nominal: 206, mass: 205.98474 },
      { nominal: 207, mass: 206.9884 },
      { nominal: 208, mass: 207.99345 },
      { nominal: 209, mass: 208.99735 },
      { nominal: 210, mass: 210.0025 },
    ],
    symbol: 'Au',
    mass: 196.96656879,
    name: 'Gold',
    monoisotopicMass: 196.96656879,
  },
  {
    number: 80,
    isotopes: [
      { nominal: 171, mass: 171.00353 },
      { nominal: 172, mass: 171.99881 },
      { nominal: 173, mass: 172.99709 },
      { nominal: 174, mass: 173.992865 },
      { nominal: 175, mass: 174.991441 },
      { nominal: 176, mass: 175.987361 },
      { nominal: 177, mass: 176.986277 },
      { nominal: 178, mass: 177.982484 },
      { nominal: 179, mass: 178.981831 },
      { nominal: 180, mass: 179.97826 },
      { nominal: 181, mass: 180.977819 },
      { nominal: 182, mass: 181.974689 },
      { nominal: 183, mass: 182.9744448 },
      { nominal: 184, mass: 183.971714 },
      { nominal: 185, mass: 184.971899 },
      { nominal: 186, mass: 185.969362 },
      { nominal: 187, mass: 186.969814 },
      { nominal: 188, mass: 187.967567 },
      { nominal: 189, mass: 188.968195 },
      { nominal: 190, mass: 189.966323 },
      { nominal: 191, mass: 190.967157 },
      { nominal: 192, mass: 191.965635 },
      { nominal: 193, mass: 192.966653 },
      { nominal: 194, mass: 193.9654491 },
      { nominal: 195, mass: 194.966721 },
      { nominal: 196, mass: 195.9658326, abundance: 0.0015 },
      { nominal: 197, mass: 196.9672128 },
      { nominal: 198, mass: 197.9667686, abundance: 0.0997 },
      { nominal: 199, mass: 198.96828064, abundance: 0.1687 },
      { nominal: 200, mass: 199.96832659, abundance: 0.231 },
      { nominal: 201, mass: 200.97030284, abundance: 0.1318 },
      { nominal: 202, mass: 201.9706434, abundance: 0.2986 },
      { nominal: 203, mass: 202.9728728 },
      { nominal: 204, mass: 203.97349398, abundance: 0.0687 },
      { nominal: 205, mass: 204.9760734 },
      { nominal: 206, mass: 205.977514 },
      { nominal: 207, mass: 206.9823 },
      { nominal: 208, mass: 207.985759 },
      { nominal: 209, mass: 208.99072 },
      { nominal: 210, mass: 209.99424 },
      { nominal: 211, mass: 210.99933 },
      { nominal: 212, mass: 212.00296 },
      { nominal: 213, mass: 213.00823 },
      { nominal: 214, mass: 214.012 },
      { nominal: 215, mass: 215.0174 },
      { nominal: 216, mass: 216.02132 },
    ],
    symbol: 'Hg',
    mass: 200.59916703455602,
    name: 'Mercury',
    monoisotopicMass: 201.9706434,
  },
  {
    number: 81,
    isotopes: [
      { nominal: 176, mass: 176.000624 },
      { nominal: 177, mass: 176.996431 },
      { nominal: 178, mass: 177.99485 },
      { nominal: 179, mass: 178.991111 },
      { nominal: 180, mass: 179.990057 },
      { nominal: 181, mass: 180.98626 },
      { nominal: 182, mass: 181.985713 },
      { nominal: 183, mass: 182.982193 },
      { nominal: 184, mass: 183.981886 },
      { nominal: 185, mass: 184.978789 },
      { nominal: 186, mass: 185.978651 },
      { nominal: 187, mass: 186.9759063 },
      { nominal: 188, mass: 187.976021 },
      { nominal: 189, mass: 188.973588 },
      { nominal: 190, mass: 189.973828 },
      { nominal: 191, mass: 190.9717842 },
      { nominal: 192, mass: 191.972225 },
      { nominal: 193, mass: 192.970502 },
      { nominal: 194, mass: 193.971081 },
      { nominal: 195, mass: 194.969774 },
      { nominal: 196, mass: 195.970481 },
      { nominal: 197, mass: 196.969576 },
      { nominal: 198, mass: 197.970483 },
      { nominal: 199, mass: 198.969877 },
      { nominal: 200, mass: 199.9709633 },
      { nominal: 201, mass: 200.970822 },
      { nominal: 202, mass: 201.972102 },
      { nominal: 203, mass: 202.9723446, abundance: 0.2952 },
      { nominal: 204, mass: 203.9738639 },
      { nominal: 205, mass: 204.9744278, abundance: 0.7048 },
      { nominal: 206, mass: 205.9761106 },
      { nominal: 207, mass: 206.9774197 },
      { nominal: 208, mass: 207.982019 },
      { nominal: 209, mass: 208.9853594 },
      { nominal: 210, mass: 209.990074 },
      { nominal: 211, mass: 210.993475 },
      { nominal: 212, mass: 211.99834 },
      { nominal: 213, mass: 213.001915 },
      { nominal: 214, mass: 214.00694 },
      { nominal: 215, mass: 215.01064 },
      { nominal: 216, mass: 216.0158 },
      { nominal: 217, mass: 217.01966 },
      { nominal: 218, mass: 218.02479 },
    ],
    symbol: 'Tl',
    mass: 204.38341283936,
    name: 'Thallium',
    monoisotopicMass: 204.9744278,
  },
  {
    number: 82,
    isotopes: [
      { nominal: 178, mass: 178.003831 },
      { nominal: 179, mass: 179.002201 },
      { nominal: 180, mass: 179.997928 },
      { nominal: 181, mass: 180.996653 },
      { nominal: 182, mass: 181.992672 },
      { nominal: 183, mass: 182.991872 },
      { nominal: 184, mass: 183.988136 },
      { nominal: 185, mass: 184.98761 },
      { nominal: 186, mass: 185.984238 },
      { nominal: 187, mass: 186.9839109 },
      { nominal: 188, mass: 187.980875 },
      { nominal: 189, mass: 188.980807 },
      { nominal: 190, mass: 189.978082 },
      { nominal: 191, mass: 190.978276 },
      { nominal: 192, mass: 191.975775 },
      { nominal: 193, mass: 192.976173 },
      { nominal: 194, mass: 193.974012 },
      { nominal: 195, mass: 194.974543 },
      { nominal: 196, mass: 195.972774 },
      { nominal: 197, mass: 196.9734312 },
      { nominal: 198, mass: 197.972034 },
      { nominal: 199, mass: 198.972913 },
      { nominal: 200, mass: 199.971819 },
      { nominal: 201, mass: 200.972883 },
      { nominal: 202, mass: 201.972152 },
      { nominal: 203, mass: 202.9733911 },
      { nominal: 204, mass: 203.973044, abundance: 0.014 },
      { nominal: 205, mass: 204.9744822 },
      { nominal: 206, mass: 205.9744657, abundance: 0.241 },
      { nominal: 207, mass: 206.9758973, abundance: 0.221 },
      { nominal: 208, mass: 207.9766525, abundance: 0.524 },
      { nominal: 209, mass: 208.9810905 },
      { nominal: 210, mass: 209.9841889 },
      { nominal: 211, mass: 210.9887371 },
      { nominal: 212, mass: 211.9918977 },
      { nominal: 213, mass: 212.9965629 },
      { nominal: 214, mass: 213.9998059 },
      { nominal: 215, mass: 215.00474 },
      { nominal: 216, mass: 216.00803 },
      { nominal: 217, mass: 217.01314 },
      { nominal: 218, mass: 218.01659 },
      { nominal: 219, mass: 219.02177 },
      { nominal: 220, mass: 220.02541 },
    ],
    symbol: 'Pb',
    mass: 207.216908063,
    name: 'Lead',
    monoisotopicMass: 207.9766525,
  },
  {
    number: 83,
    isotopes: [
      { nominal: 184, mass: 184.001275 },
      { nominal: 185, mass: 184.9976 },
      { nominal: 186, mass: 185.996644 },
      { nominal: 187, mass: 186.993147 },
      { nominal: 188, mass: 187.992287 },
      { nominal: 189, mass: 188.989195 },
      { nominal: 190, mass: 189.988622 },
      { nominal: 191, mass: 190.9857866 },
      { nominal: 192, mass: 191.985469 },
      { nominal: 193, mass: 192.98296 },
      { nominal: 194, mass: 193.982785 },
      { nominal: 195, mass: 194.9806488 },
      { nominal: 196, mass: 195.980667 },
      { nominal: 197, mass: 196.9788651 },
      { nominal: 198, mass: 197.979206 },
      { nominal: 199, mass: 198.977673 },
      { nominal: 200, mass: 199.978131 },
      { nominal: 201, mass: 200.97701 },
      { nominal: 202, mass: 201.977734 },
      { nominal: 203, mass: 202.976893 },
      { nominal: 204, mass: 203.9778361 },
      { nominal: 205, mass: 204.9773867 },
      { nominal: 206, mass: 205.9784993 },
      { nominal: 207, mass: 206.978471 },
      { nominal: 208, mass: 207.9797425 },
      { nominal: 209, mass: 208.9803991, abundance: 1 },
      { nominal: 210, mass: 209.9841207 },
      { nominal: 211, mass: 210.9872697 },
      { nominal: 212, mass: 211.991286 },
      { nominal: 213, mass: 212.9943851 },
      { nominal: 214, mass: 213.998712 },
      { nominal: 215, mass: 215.00177 },
      { nominal: 216, mass: 216.006306 },
      { nominal: 217, mass: 217.009372 },
      { nominal: 218, mass: 218.014188 },
      { nominal: 219, mass: 219.01748 },
      { nominal: 220, mass: 220.02235 },
      { nominal: 221, mass: 221.02587 },
      { nominal: 222, mass: 222.03078 },
      { nominal: 223, mass: 223.0345 },
      { nominal: 224, mass: 224.03947 },
    ],
    symbol: 'Bi',
    mass: 208.9803991,
    name: 'Bismuth',
    monoisotopicMass: 208.9803991,
  },
  {
    number: 84,
    isotopes: [
      { nominal: 186, mass: 186.004393 },
      { nominal: 187, mass: 187.003041 },
      { nominal: 188, mass: 187.999416 },
      { nominal: 189, mass: 188.998473 },
      { nominal: 190, mass: 189.995101 },
      { nominal: 191, mass: 190.9945585 },
      { nominal: 192, mass: 191.991336 },
      { nominal: 193, mass: 192.991026 },
      { nominal: 194, mass: 193.988186 },
      { nominal: 195, mass: 194.988126 },
      { nominal: 196, mass: 195.985526 },
      { nominal: 197, mass: 196.98566 },
      { nominal: 198, mass: 197.983389 },
      { nominal: 199, mass: 198.983667 },
      { nominal: 200, mass: 199.981799 },
      { nominal: 201, mass: 200.9822598 },
      { nominal: 202, mass: 201.980758 },
      { nominal: 203, mass: 202.9814161 },
      { nominal: 204, mass: 203.98031 },
      { nominal: 205, mass: 204.981203 },
      { nominal: 206, mass: 205.980474 },
      { nominal: 207, mass: 206.9815938 },
      { nominal: 208, mass: 207.9812461 },
      { nominal: 209, mass: 208.9824308 },
      { nominal: 210, mass: 209.9828741 },
      { nominal: 211, mass: 210.9866536 },
      { nominal: 212, mass: 211.9888684 },
      { nominal: 213, mass: 212.9928576 },
      { nominal: 214, mass: 213.9952017 },
      { nominal: 215, mass: 214.9994201 },
      { nominal: 216, mass: 216.0019152 },
      { nominal: 217, mass: 217.0063182 },
      { nominal: 218, mass: 218.0089735 },
      { nominal: 219, mass: 219.013614 },
      { nominal: 220, mass: 220.016386 },
      { nominal: 221, mass: 221.021228 },
      { nominal: 222, mass: 222.02414 },
      { nominal: 223, mass: 223.02907 },
      { nominal: 224, mass: 224.03211 },
      { nominal: 225, mass: 225.03707 },
      { nominal: 226, mass: 226.04031 },
      { nominal: 227, mass: 227.04539 },
    ],
    symbol: 'Po',
    mass: null,
    name: 'Polonium',
  },
  {
    number: 85,
    isotopes: [
      { nominal: 191, mass: 191.004148 },
      { nominal: 192, mass: 192.003152 },
      { nominal: 193, mass: 192.999927 },
      { nominal: 194, mass: 193.999236 },
      { nominal: 195, mass: 194.9962685 },
      { nominal: 196, mass: 195.9958 },
      { nominal: 197, mass: 196.993189 },
      { nominal: 198, mass: 197.992784 },
      { nominal: 199, mass: 198.9905277 },
      { nominal: 200, mass: 199.990351 },
      { nominal: 201, mass: 200.9884171 },
      { nominal: 202, mass: 201.98863 },
      { nominal: 203, mass: 202.986943 },
      { nominal: 204, mass: 203.987251 },
      { nominal: 205, mass: 204.986076 },
      { nominal: 206, mass: 205.986657 },
      { nominal: 207, mass: 206.9858 },
      { nominal: 208, mass: 207.9866133 },
      { nominal: 209, mass: 208.9861702 },
      { nominal: 210, mass: 209.9871479 },
      { nominal: 211, mass: 210.9874966 },
      { nominal: 212, mass: 211.9907377 },
      { nominal: 213, mass: 212.992937 },
      { nominal: 214, mass: 213.9963721 },
      { nominal: 215, mass: 214.9986528 },
      { nominal: 216, mass: 216.0024236 },
      { nominal: 217, mass: 217.0047192 },
      { nominal: 218, mass: 218.008695 },
      { nominal: 219, mass: 219.0111618 },
      { nominal: 220, mass: 220.015433 },
      { nominal: 221, mass: 221.018017 },
      { nominal: 222, mass: 222.022494 },
      { nominal: 223, mass: 223.025151 },
      { nominal: 224, mass: 224.029749 },
      { nominal: 225, mass: 225.03263 },
      { nominal: 226, mass: 226.03716 },
      { nominal: 227, mass: 227.04024 },
      { nominal: 228, mass: 228.04475 },
      { nominal: 229, mass: 229.04812 },
    ],
    symbol: 'At',
    mass: null,
    name: 'Astatine',
  },
  {
    number: 86,
    isotopes: [
      { nominal: 193, mass: 193.009708 },
      { nominal: 194, mass: 194.006144 },
      { nominal: 195, mass: 195.005422 },
      { nominal: 196, mass: 196.002116 },
      { nominal: 197, mass: 197.001585 },
      { nominal: 198, mass: 197.998679 },
      { nominal: 199, mass: 198.99839 },
      { nominal: 200, mass: 199.99569 },
      { nominal: 201, mass: 200.995628 },
      { nominal: 202, mass: 201.993264 },
      { nominal: 203, mass: 202.993388 },
      { nominal: 204, mass: 203.99143 },
      { nominal: 205, mass: 204.991719 },
      { nominal: 206, mass: 205.990214 },
      { nominal: 207, mass: 206.9907303 },
      { nominal: 208, mass: 207.989635 },
      { nominal: 209, mass: 208.990415 },
      { nominal: 210, mass: 209.9896891 },
      { nominal: 211, mass: 210.9906011 },
      { nominal: 212, mass: 211.9907039 },
      { nominal: 213, mass: 212.9938831 },
      { nominal: 214, mass: 213.995363 },
      { nominal: 215, mass: 214.9987459 },
      { nominal: 216, mass: 216.0002719 },
      { nominal: 217, mass: 217.003928 },
      { nominal: 218, mass: 218.0056016 },
      { nominal: 219, mass: 219.0094804 },
      { nominal: 220, mass: 220.0113941 },
      { nominal: 221, mass: 221.0155371 },
      { nominal: 222, mass: 222.0175782 },
      { nominal: 223, mass: 223.0218893 },
      { nominal: 224, mass: 224.024096 },
      { nominal: 225, mass: 225.028486 },
      { nominal: 226, mass: 226.030861 },
      { nominal: 227, mass: 227.035304 },
      { nominal: 228, mass: 228.037835 },
      { nominal: 229, mass: 229.042257 },
      { nominal: 230, mass: 230.04514 },
      { nominal: 231, mass: 231.04987 },
    ],
    symbol: 'Rn',
    mass: null,
    name: 'Radon',
  },
  {
    number: 87,
    isotopes: [
      { nominal: 199, mass: 199.007259 },
      { nominal: 200, mass: 200.006586 },
      { nominal: 201, mass: 201.003867 },
      { nominal: 202, mass: 202.00332 },
      { nominal: 203, mass: 203.0009407 },
      { nominal: 204, mass: 204.000652 },
      { nominal: 205, mass: 204.9985939 },
      { nominal: 206, mass: 205.998666 },
      { nominal: 207, mass: 206.996946 },
      { nominal: 208, mass: 207.997138 },
      { nominal: 209, mass: 208.995955 },
      { nominal: 210, mass: 209.996422 },
      { nominal: 211, mass: 210.995556 },
      { nominal: 212, mass: 211.9962257 },
      { nominal: 213, mass: 212.996186 },
      { nominal: 214, mass: 213.9989713 },
      { nominal: 215, mass: 215.0003418 },
      { nominal: 216, mass: 216.0031899 },
      { nominal: 217, mass: 217.0046323 },
      { nominal: 218, mass: 218.0075787 },
      { nominal: 219, mass: 219.0092524 },
      { nominal: 220, mass: 220.0123277 },
      { nominal: 221, mass: 221.0142552 },
      { nominal: 222, mass: 222.017552 },
      { nominal: 223, mass: 223.019736 },
      { nominal: 224, mass: 224.023398 },
      { nominal: 225, mass: 225.025573 },
      { nominal: 226, mass: 226.029566 },
      { nominal: 227, mass: 227.031869 },
      { nominal: 228, mass: 228.035823 },
      { nominal: 229, mass: 229.038298 },
      { nominal: 230, mass: 230.042416 },
      { nominal: 231, mass: 231.045158 },
      { nominal: 232, mass: 232.04937 },
      { nominal: 233, mass: 233.05264 },
    ],
    symbol: 'Fr',
    mass: null,
    name: 'Francium',
  },
  {
    number: 88,
    isotopes: [
      { nominal: 201, mass: 201.01271 },
      { nominal: 202, mass: 202.00976 },
      { nominal: 203, mass: 203.009304 },
      { nominal: 204, mass: 204.006492 },
      { nominal: 205, mass: 205.006268 },
      { nominal: 206, mass: 206.003828 },
      { nominal: 207, mass: 207.003799 },
      { nominal: 208, mass: 208.001841 },
      { nominal: 209, mass: 209.00199 },
      { nominal: 210, mass: 210.000494 },
      { nominal: 211, mass: 211.0008932 },
      { nominal: 212, mass: 211.999787 },
      { nominal: 213, mass: 213.000384 },
      { nominal: 214, mass: 214.0000997 },
      { nominal: 215, mass: 215.0027204 },
      { nominal: 216, mass: 216.0035334 },
      { nominal: 217, mass: 217.0063207 },
      { nominal: 218, mass: 218.007141 },
      { nominal: 219, mass: 219.0100855 },
      { nominal: 220, mass: 220.0110259 },
      { nominal: 221, mass: 221.0139177 },
      { nominal: 222, mass: 222.0153748 },
      { nominal: 223, mass: 223.0185023 },
      { nominal: 224, mass: 224.020212 },
      { nominal: 225, mass: 225.0236119 },
      { nominal: 226, mass: 226.0254103 },
      { nominal: 227, mass: 227.0291783 },
      { nominal: 228, mass: 228.0310707 },
      { nominal: 229, mass: 229.034942 },
      { nominal: 230, mass: 230.037055 },
      { nominal: 231, mass: 231.041027 },
      { nominal: 232, mass: 232.0434753 },
      { nominal: 233, mass: 233.047582 },
      { nominal: 234, mass: 234.050342 },
      { nominal: 235, mass: 235.05497 },
    ],
    symbol: 'Ra',
    mass: null,
    name: 'Radium',
  },
  {
    number: 89,
    isotopes: [
      { nominal: 206, mass: 206.014452 },
      { nominal: 207, mass: 207.011966 },
      { nominal: 208, mass: 208.01155 },
      { nominal: 209, mass: 209.009495 },
      { nominal: 210, mass: 210.009436 },
      { nominal: 211, mass: 211.007732 },
      { nominal: 212, mass: 212.007813 },
      { nominal: 213, mass: 213.006609 },
      { nominal: 214, mass: 214.006918 },
      { nominal: 215, mass: 215.006475 },
      { nominal: 216, mass: 216.008743 },
      { nominal: 217, mass: 217.009344 },
      { nominal: 218, mass: 218.011642 },
      { nominal: 219, mass: 219.012421 },
      { nominal: 220, mass: 220.0147549 },
      { nominal: 221, mass: 221.015592 },
      { nominal: 222, mass: 222.0178442 },
      { nominal: 223, mass: 223.0191377 },
      { nominal: 224, mass: 224.0217232 },
      { nominal: 225, mass: 225.02323 },
      { nominal: 226, mass: 226.0260984 },
      { nominal: 227, mass: 227.0277523 },
      { nominal: 228, mass: 228.0310215 },
      { nominal: 229, mass: 229.032956 },
      { nominal: 230, mass: 230.036327 },
      { nominal: 231, mass: 231.038393 },
      { nominal: 232, mass: 232.042034 },
      { nominal: 233, mass: 233.044346 },
      { nominal: 234, mass: 234.048139 },
      { nominal: 235, mass: 235.05084 },
      { nominal: 236, mass: 236.054988 },
      { nominal: 237, mass: 237.05827 },
    ],
    symbol: 'Ac',
    mass: null,
    name: 'Actinium',
  },
  {
    number: 90,
    isotopes: [
      { nominal: 208, mass: 208.0179 },
      { nominal: 209, mass: 209.017753 },
      { nominal: 210, mass: 210.015094 },
      { nominal: 211, mass: 211.014929 },
      { nominal: 212, mass: 212.012988 },
      { nominal: 213, mass: 213.013009 },
      { nominal: 214, mass: 214.0115 },
      { nominal: 215, mass: 215.0117248 },
      { nominal: 216, mass: 216.011056 },
      { nominal: 217, mass: 217.013117 },
      { nominal: 218, mass: 218.013276 },
      { nominal: 219, mass: 219.015537 },
      { nominal: 220, mass: 220.015748 },
      { nominal: 221, mass: 221.018184 },
      { nominal: 222, mass: 222.018469 },
      { nominal: 223, mass: 223.0208119 },
      { nominal: 224, mass: 224.021464 },
      { nominal: 225, mass: 225.0239514 },
      { nominal: 226, mass: 226.0249034 },
      { nominal: 227, mass: 227.0277042 },
      { nominal: 228, mass: 228.0287413 },
      { nominal: 229, mass: 229.0317627 },
      { nominal: 230, mass: 230.0331341 },
      { nominal: 231, mass: 231.0363046 },
      { nominal: 232, mass: 232.0380558, abundance: 1 },
      { nominal: 233, mass: 233.0415823 },
      { nominal: 234, mass: 234.0436014 },
      { nominal: 235, mass: 235.047255 },
      { nominal: 236, mass: 236.049657 },
      { nominal: 237, mass: 237.053629 },
      { nominal: 238, mass: 238.0565 },
      { nominal: 239, mass: 239.06077 },
    ],
    symbol: 'Th',
    mass: 232.0380558,
    name: 'Thorium',
    monoisotopicMass: 232.0380558,
  },
  {
    number: 91,
    isotopes: [
      { nominal: 212, mass: 212.023203 },
      { nominal: 213, mass: 213.021109 },
      { nominal: 214, mass: 214.020918 },
      { nominal: 215, mass: 215.019183 },
      { nominal: 216, mass: 216.019109 },
      { nominal: 217, mass: 217.018325 },
      { nominal: 218, mass: 218.020059 },
      { nominal: 219, mass: 219.019904 },
      { nominal: 220, mass: 220.021705 },
      { nominal: 221, mass: 221.021875 },
      { nominal: 222, mass: 222.023784 },
      { nominal: 223, mass: 223.023963 },
      { nominal: 224, mass: 224.0256176 },
      { nominal: 225, mass: 225.026131 },
      { nominal: 226, mass: 226.027948 },
      { nominal: 227, mass: 227.0288054 },
      { nominal: 228, mass: 228.0310517 },
      { nominal: 229, mass: 229.0320972 },
      { nominal: 230, mass: 230.034541 },
      { nominal: 231, mass: 231.0358842, abundance: 1 },
      { nominal: 232, mass: 232.0385917 },
      { nominal: 233, mass: 233.0402472 },
      { nominal: 234, mass: 234.0433072 },
      { nominal: 235, mass: 235.045399 },
      { nominal: 236, mass: 236.048668 },
      { nominal: 237, mass: 237.051023 },
      { nominal: 238, mass: 238.054637 },
      { nominal: 239, mass: 239.05726 },
      { nominal: 240, mass: 240.06098 },
      { nominal: 241, mass: 241.06408 },
    ],
    symbol: 'Pa',
    mass: 231.0358842,
    name: 'Protactinium',
    monoisotopicMass: 231.0358842,
  },
  {
    number: 92,
    isotopes: [
      { nominal: 217, mass: 217.02466 },
      { nominal: 218, mass: 218.023523 },
      { nominal: 219, mass: 219.024999 },
      { nominal: 220, mass: 220.02462 },
      { nominal: 221, mass: 221.02628 },
      { nominal: 222, mass: 222.026 },
      { nominal: 223, mass: 223.027739 },
      { nominal: 224, mass: 224.027605 },
      { nominal: 225, mass: 225.029391 },
      { nominal: 226, mass: 226.029339 },
      { nominal: 227, mass: 227.031157 },
      { nominal: 228, mass: 228.031371 },
      { nominal: 229, mass: 229.0335063 },
      { nominal: 230, mass: 230.0339401 },
      { nominal: 231, mass: 231.0362939 },
      { nominal: 232, mass: 232.0371563 },
      { nominal: 233, mass: 233.0396355 },
      { nominal: 234, mass: 234.0409523, abundance: 0.000054 },
      { nominal: 235, mass: 235.0439301, abundance: 0.007204 },
      { nominal: 236, mass: 236.0455682 },
      { nominal: 237, mass: 237.0487304 },
      { nominal: 238, mass: 238.0507884, abundance: 0.992742 },
      { nominal: 239, mass: 239.0542935 },
      { nominal: 240, mass: 240.0565934 },
      { nominal: 241, mass: 241.06033 },
      { nominal: 242, mass: 242.06293 },
      { nominal: 243, mass: 243.06699 },
    ],
    symbol: 'U',
    mass: 238.0289104616574,
    name: 'Uranium',
    monoisotopicMass: 238.0507884,
  },
  {
    number: 93,
    isotopes: [
      { nominal: 219, mass: 219.03143 },
      { nominal: 220, mass: 220.03254 },
      { nominal: 221, mass: 221.03204 },
      { nominal: 222, mass: 222.0333 },
      { nominal: 223, mass: 223.03285 },
      { nominal: 224, mass: 224.03422 },
      { nominal: 225, mass: 225.033911 },
      { nominal: 226, mass: 226.035188 },
      { nominal: 227, mass: 227.034957 },
      { nominal: 228, mass: 228.036067 },
      { nominal: 229, mass: 229.036264 },
      { nominal: 230, mass: 230.037828 },
      { nominal: 231, mass: 231.038245 },
      { nominal: 232, mass: 232.04011 },
      { nominal: 233, mass: 233.040741 },
      { nominal: 234, mass: 234.0428953 },
      { nominal: 235, mass: 235.0440635 },
      { nominal: 236, mass: 236.04657 },
      { nominal: 237, mass: 237.0481736 },
      { nominal: 238, mass: 238.0509466 },
      { nominal: 239, mass: 239.0529392 },
      { nominal: 240, mass: 240.056165 },
      { nominal: 241, mass: 241.058253 },
      { nominal: 242, mass: 242.06164 },
      { nominal: 243, mass: 243.06428 },
      { nominal: 244, mass: 244.06785 },
      { nominal: 245, mass: 245.0708 },
    ],
    symbol: 'Np',
    mass: null,
    name: 'Neptunium',
  },
  {
    number: 94,
    isotopes: [
      { nominal: 228, mass: 228.038732 },
      { nominal: 229, mass: 229.040144 },
      { nominal: 230, mass: 230.03965 },
      { nominal: 231, mass: 231.041102 },
      { nominal: 232, mass: 232.041185 },
      { nominal: 233, mass: 233.042998 },
      { nominal: 234, mass: 234.0433174 },
      { nominal: 235, mass: 235.045286 },
      { nominal: 236, mass: 236.0460581 },
      { nominal: 237, mass: 237.0484098 },
      { nominal: 238, mass: 238.0495601 },
      { nominal: 239, mass: 239.0521636 },
      { nominal: 240, mass: 240.0538138 },
      { nominal: 241, mass: 241.0568517 },
      { nominal: 242, mass: 242.0587428 },
      { nominal: 243, mass: 243.0620036 },
      { nominal: 244, mass: 244.0642053 },
      { nominal: 245, mass: 245.067826 },
      { nominal: 246, mass: 246.070205 },
      { nominal: 247, mass: 247.07419 },
    ],
    symbol: 'Pu',
    mass: null,
    name: 'Plutonium',
  },
  {
    number: 95,
    isotopes: [
      { nominal: 230, mass: 230.04609 },
      { nominal: 231, mass: 231.04556 },
      { nominal: 232, mass: 232.04645 },
      { nominal: 233, mass: 233.04644 },
      { nominal: 234, mass: 234.04773 },
      { nominal: 235, mass: 235.047908 },
      { nominal: 236, mass: 236.04943 },
      { nominal: 237, mass: 237.049996 },
      { nominal: 238, mass: 238.051985 },
      { nominal: 239, mass: 239.0530247 },
      { nominal: 240, mass: 240.0553 },
      { nominal: 241, mass: 241.0568293 },
      { nominal: 242, mass: 242.0595494 },
      { nominal: 243, mass: 243.0613813 },
      { nominal: 244, mass: 244.0642851 },
      { nominal: 245, mass: 245.0664548 },
      { nominal: 246, mass: 246.069775 },
      { nominal: 247, mass: 247.07209 },
      { nominal: 248, mass: 248.07575 },
      { nominal: 249, mass: 249.07848 },
    ],
    symbol: 'Am',
    name: 'Americium',
    mass: null,
  },
  {
    number: 96,
    isotopes: [
      { nominal: 232, mass: 232.04982 },
      { nominal: 233, mass: 233.05077 },
      { nominal: 234, mass: 234.05016 },
      { nominal: 235, mass: 235.05154 },
      { nominal: 236, mass: 236.051374 },
      { nominal: 237, mass: 237.052869 },
      { nominal: 238, mass: 238.053081 },
      { nominal: 239, mass: 239.05491 },
      { nominal: 240, mass: 240.0555297 },
      { nominal: 241, mass: 241.0576532 },
      { nominal: 242, mass: 242.058836 },
      { nominal: 243, mass: 243.0613893 },
      { nominal: 244, mass: 244.0627528 },
      { nominal: 245, mass: 245.0654915 },
      { nominal: 246, mass: 246.0672238 },
      { nominal: 247, mass: 247.0703541 },
      { nominal: 248, mass: 248.0723499 },
      { nominal: 249, mass: 249.0759548 },
      { nominal: 250, mass: 250.078358 },
      { nominal: 251, mass: 251.082286 },
      { nominal: 252, mass: 252.08487 },
    ],
    symbol: 'Cm',
    name: 'Curium',
    mass: null,
  },
  {
    number: 97,
    isotopes: [
      { nominal: 234, mass: 234.05727 },
      { nominal: 235, mass: 235.05658 },
      { nominal: 236, mass: 236.05748 },
      { nominal: 237, mass: 237.0571 },
      { nominal: 238, mass: 238.0582 },
      { nominal: 239, mass: 239.05824 },
      { nominal: 240, mass: 240.05976 },
      { nominal: 241, mass: 241.06016 },
      { nominal: 242, mass: 242.06198 },
      { nominal: 243, mass: 243.0630078 },
      { nominal: 244, mass: 244.065181 },
      { nominal: 245, mass: 245.0663618 },
      { nominal: 246, mass: 246.068673 },
      { nominal: 247, mass: 247.0703073 },
      { nominal: 248, mass: 248.073088 },
      { nominal: 249, mass: 249.0749877 },
      { nominal: 250, mass: 250.0783167 },
      { nominal: 251, mass: 251.080762 },
      { nominal: 252, mass: 252.08431 },
      { nominal: 253, mass: 253.08688 },
      { nominal: 254, mass: 254.0906 },
    ],
    symbol: 'Bk',
    name: 'Berkelium',
    mass: null,
  },
  {
    number: 98,
    isotopes: [
      { nominal: 237, mass: 237.062198 },
      { nominal: 238, mass: 238.06149 },
      { nominal: 239, mass: 239.06253 },
      { nominal: 240, mass: 240.062256 },
      { nominal: 241, mass: 241.06369 },
      { nominal: 242, mass: 242.063754 },
      { nominal: 243, mass: 243.06548 },
      { nominal: 244, mass: 244.0660008 },
      { nominal: 245, mass: 245.0680487 },
      { nominal: 246, mass: 246.0688055 },
      { nominal: 247, mass: 247.070965 },
      { nominal: 248, mass: 248.0721851 },
      { nominal: 249, mass: 249.0748539 },
      { nominal: 250, mass: 250.0764062 },
      { nominal: 251, mass: 251.0795886 },
      { nominal: 252, mass: 252.0816272 },
      { nominal: 253, mass: 253.0851345 },
      { nominal: 254, mass: 254.087324 },
      { nominal: 255, mass: 255.09105 },
      { nominal: 256, mass: 256.09344 },
    ],
    symbol: 'Cf',
    name: 'Californium',
    mass: null,
  },
  {
    number: 99,
    isotopes: [
      { nominal: 239, mass: 239.06823 },
      { nominal: 240, mass: 240.06892 },
      { nominal: 241, mass: 241.06856 },
      { nominal: 242, mass: 242.06957 },
      { nominal: 243, mass: 243.06951 },
      { nominal: 244, mass: 244.07088 },
      { nominal: 245, mass: 245.07125 },
      { nominal: 246, mass: 246.0729 },
      { nominal: 247, mass: 247.073622 },
      { nominal: 248, mass: 248.075471 },
      { nominal: 249, mass: 249.076411 },
      { nominal: 250, mass: 250.07861 },
      { nominal: 251, mass: 251.0799936 },
      { nominal: 252, mass: 252.08298 },
      { nominal: 253, mass: 253.0848257 },
      { nominal: 254, mass: 254.0880222 },
      { nominal: 255, mass: 255.090275 },
      { nominal: 256, mass: 256.0936 },
      { nominal: 257, mass: 257.09598 },
      { nominal: 258, mass: 258.09952 },
    ],
    symbol: 'Es',
    name: 'Einsteinium',
    mass: null,
  },
  {
    number: 100,
    isotopes: [
      { nominal: 241, mass: 241.07421 },
      { nominal: 242, mass: 242.07343 },
      { nominal: 243, mass: 243.07446 },
      { nominal: 244, mass: 244.07404 },
      { nominal: 245, mass: 245.07535 },
      { nominal: 246, mass: 246.07535 },
      { nominal: 247, mass: 247.07694 },
      { nominal: 248, mass: 248.0771865 },
      { nominal: 249, mass: 249.0789275 },
      { nominal: 250, mass: 250.079521 },
      { nominal: 251, mass: 251.08154 },
      { nominal: 252, mass: 252.0824671 },
      { nominal: 253, mass: 253.0851846 },
      { nominal: 254, mass: 254.0868544 },
      { nominal: 255, mass: 255.089964 },
      { nominal: 256, mass: 256.0917745 },
      { nominal: 257, mass: 257.0951061 },
      { nominal: 258, mass: 258.09708 },
      { nominal: 259, mass: 259.1006 },
      { nominal: 260, mass: 260.10281 },
    ],
    symbol: 'Fm',
    name: 'Fermium',
    mass: null,
  },
  {
    number: 101,
    isotopes: [
      { nominal: 245, mass: 245.08081 },
      { nominal: 246, mass: 246.08171 },
      { nominal: 247, mass: 247.08152 },
      { nominal: 248, mass: 248.08282 },
      { nominal: 249, mass: 249.08291 },
      { nominal: 250, mass: 250.08441 },
      { nominal: 251, mass: 251.084774 },
      { nominal: 252, mass: 252.08643 },
      { nominal: 253, mass: 253.087144 },
      { nominal: 254, mass: 254.08959 },
      { nominal: 255, mass: 255.0910841 },
      { nominal: 256, mass: 256.09389 },
      { nominal: 257, mass: 257.0955424 },
      { nominal: 258, mass: 258.0984315 },
      { nominal: 259, mass: 259.10051 },
      { nominal: 260, mass: 260.10365 },
      { nominal: 261, mass: 261.10583 },
      { nominal: 262, mass: 262.1091 },
    ],
    symbol: 'Md',
    name: 'Mendelevium',
    mass: null,
  },
  {
    number: 102,
    isotopes: [
      { nominal: 248, mass: 248.08655 },
      { nominal: 249, mass: 249.0878 },
      { nominal: 250, mass: 250.08756 },
      { nominal: 251, mass: 251.08894 },
      { nominal: 252, mass: 252.088967 },
      { nominal: 253, mass: 253.0905641 },
      { nominal: 254, mass: 254.090956 },
      { nominal: 255, mass: 255.093191 },
      { nominal: 256, mass: 256.0942829 },
      { nominal: 257, mass: 257.0968878 },
      { nominal: 258, mass: 258.09821 },
      { nominal: 259, mass: 259.10103 },
      { nominal: 260, mass: 260.10264 },
      { nominal: 261, mass: 261.1057 },
      { nominal: 262, mass: 262.10746 },
      { nominal: 263, mass: 263.11071 },
      { nominal: 264, mass: 264.11273 },
    ],
    symbol: 'No',
    name: 'Nobelium',
    mass: null,
  },
  {
    number: 103,
    isotopes: [
      { nominal: 251, mass: 251.09418 },
      { nominal: 252, mass: 252.09526 },
      { nominal: 253, mass: 253.09509 },
      { nominal: 254, mass: 254.09648 },
      { nominal: 255, mass: 255.096562 },
      { nominal: 256, mass: 256.098494 },
      { nominal: 257, mass: 257.099418 },
      { nominal: 258, mass: 258.10176 },
      { nominal: 259, mass: 259.102902 },
      { nominal: 260, mass: 260.1055 },
      { nominal: 261, mass: 261.10688 },
      { nominal: 262, mass: 262.10961 },
      { nominal: 263, mass: 263.11136 },
      { nominal: 264, mass: 264.1142 },
      { nominal: 265, mass: 265.11619 },
      { nominal: 266, mass: 266.11983 },
    ],
    symbol: 'Lr',
    name: 'Lawrencium',
    mass: null,
  },
  {
    number: 104,
    isotopes: [
      { nominal: 253, mass: 253.10044 },
      { nominal: 254, mass: 254.10005 },
      { nominal: 255, mass: 255.10127 },
      { nominal: 256, mass: 256.101152 },
      { nominal: 257, mass: 257.102918 },
      { nominal: 258, mass: 258.103428 },
      { nominal: 259, mass: 259.105596 },
      { nominal: 260, mass: 260.10644 },
      { nominal: 261, mass: 261.108773 },
      { nominal: 262, mass: 262.10992 },
      { nominal: 263, mass: 263.11249 },
      { nominal: 264, mass: 264.11388 },
      { nominal: 265, mass: 265.11668 },
      { nominal: 266, mass: 266.11817 },
      { nominal: 267, mass: 267.12179 },
      { nominal: 268, mass: 268.12397 },
    ],
    symbol: 'Rf',
    name: 'Rutherfordium',
    mass: null,
  },
  {
    number: 105,
    isotopes: [
      { nominal: 255, mass: 255.10707 },
      { nominal: 256, mass: 256.10789 },
      { nominal: 257, mass: 257.10758 },
      { nominal: 258, mass: 258.10928 },
      { nominal: 259, mass: 259.109492 },
      { nominal: 260, mass: 260.1113 },
      { nominal: 261, mass: 261.11192 },
      { nominal: 262, mass: 262.11407 },
      { nominal: 263, mass: 263.11499 },
      { nominal: 264, mass: 264.11741 },
      { nominal: 265, mass: 265.11861 },
      { nominal: 266, mass: 266.12103 },
      { nominal: 267, mass: 267.12247 },
      { nominal: 268, mass: 268.12567 },
      { nominal: 269, mass: 269.12791 },
      { nominal: 270, mass: 270.13136 },
    ],
    symbol: 'Db',
    name: 'Dubnium',
    mass: null,
  },
  {
    number: 106,
    isotopes: [
      { nominal: 258, mass: 258.11298 },
      { nominal: 259, mass: 259.1144 },
      { nominal: 260, mass: 260.114384 },
      { nominal: 261, mass: 261.115949 },
      { nominal: 262, mass: 262.116337 },
      { nominal: 263, mass: 263.11829 },
      { nominal: 264, mass: 264.11893 },
      { nominal: 265, mass: 265.12109 },
      { nominal: 266, mass: 266.12198 },
      { nominal: 267, mass: 267.12436 },
      { nominal: 268, mass: 268.12539 },
      { nominal: 269, mass: 269.12863 },
      { nominal: 270, mass: 270.13043 },
      { nominal: 271, mass: 271.13393 },
      { nominal: 272, mass: 272.13589 },
      { nominal: 273, mass: 273.13958 },
    ],
    symbol: 'Sg',
    name: 'Seaborgium',
    mass: null,
  },
  {
    number: 107,
    isotopes: [
      { nominal: 260, mass: 260.12166 },
      { nominal: 261, mass: 261.12145 },
      { nominal: 262, mass: 262.12297 },
      { nominal: 263, mass: 263.12292 },
      { nominal: 264, mass: 264.12459 },
      { nominal: 265, mass: 265.12491 },
      { nominal: 266, mass: 266.12679 },
      { nominal: 267, mass: 267.1275 },
      { nominal: 268, mass: 268.12969 },
      { nominal: 269, mass: 269.13042 },
      { nominal: 270, mass: 270.13336 },
      { nominal: 271, mass: 271.13526 },
      { nominal: 272, mass: 272.13826 },
      { nominal: 273, mass: 273.14024 },
      { nominal: 274, mass: 274.14355 },
      { nominal: 275, mass: 275.14567 },
    ],
    symbol: 'Bh',
    name: 'Bohrium',
    mass: null,
  },
  {
    number: 108,
    isotopes: [
      { nominal: 263, mass: 263.12852 },
      { nominal: 264, mass: 264.128357 },
      { nominal: 265, mass: 265.129793 },
      { nominal: 266, mass: 266.130046 },
      { nominal: 267, mass: 267.13167 },
      { nominal: 268, mass: 268.13186 },
      { nominal: 269, mass: 269.13375 },
      { nominal: 270, mass: 270.13429 },
      { nominal: 271, mass: 271.13717 },
      { nominal: 272, mass: 272.1385 },
      { nominal: 273, mass: 273.14168 },
      { nominal: 274, mass: 274.1433 },
      { nominal: 275, mass: 275.14667 },
      { nominal: 276, mass: 276.14846 },
      { nominal: 277, mass: 277.1519 },
    ],
    symbol: 'Hs',
    name: 'Hassium',
    mass: null,
  },
  {
    number: 109,
    isotopes: [
      { nominal: 265, mass: 265.136 },
      { nominal: 266, mass: 266.13737 },
      { nominal: 267, mass: 267.13719 },
      { nominal: 268, mass: 268.13865 },
      { nominal: 269, mass: 269.13882 },
      { nominal: 270, mass: 270.14033 },
      { nominal: 271, mass: 271.14074 },
      { nominal: 272, mass: 272.14341 },
      { nominal: 273, mass: 273.1444 },
      { nominal: 274, mass: 274.14724 },
      { nominal: 275, mass: 275.14882 },
      { nominal: 276, mass: 276.15159 },
      { nominal: 277, mass: 277.15327 },
      { nominal: 278, mass: 278.15631 },
      { nominal: 279, mass: 279.15808 },
    ],
    symbol: 'Mt',
    name: 'Meitnerium',
    mass: null,
  },
  {
    number: 110,
    isotopes: [
      { nominal: 267, mass: 267.14377 },
      { nominal: 268, mass: 268.14348 },
      { nominal: 269, mass: 269.144752 },
      { nominal: 270, mass: 270.144584 },
      { nominal: 271, mass: 271.14595 },
      { nominal: 272, mass: 272.14602 },
      { nominal: 273, mass: 273.14856 },
      { nominal: 274, mass: 274.14941 },
      { nominal: 275, mass: 275.15203 },
      { nominal: 276, mass: 276.15303 },
      { nominal: 277, mass: 277.15591 },
      { nominal: 278, mass: 278.15704 },
      { nominal: 279, mass: 279.1601 },
      { nominal: 280, mass: 280.16131 },
      { nominal: 281, mass: 281.16451 },
    ],
    symbol: 'Ds',
    name: 'Darmstadtium',
    mass: null,
  },
  {
    number: 111,
    isotopes: [
      { nominal: 272, mass: 272.15327 },
      { nominal: 273, mass: 273.15313 },
      { nominal: 274, mass: 274.15525 },
      { nominal: 275, mass: 275.15594 },
      { nominal: 276, mass: 276.15833 },
      { nominal: 277, mass: 277.15907 },
      { nominal: 278, mass: 278.16149 },
      { nominal: 279, mass: 279.16272 },
      { nominal: 280, mass: 280.16514 },
      { nominal: 281, mass: 281.16636 },
      { nominal: 282, mass: 282.16912 },
      { nominal: 283, mass: 283.17054 },
    ],
    symbol: 'Rg',
    name: 'Roentgenium',
    mass: null,
  },
  {
    number: 112,
    isotopes: [
      { nominal: 276, mass: 276.16141 },
      { nominal: 277, mass: 277.16364 },
      { nominal: 278, mass: 278.16416 },
      { nominal: 279, mass: 279.16654 },
      { nominal: 280, mass: 280.16715 },
      { nominal: 281, mass: 281.16975 },
      { nominal: 282, mass: 282.1705 },
      { nominal: 283, mass: 283.17327 },
      { nominal: 284, mass: 284.17416 },
      { nominal: 285, mass: 285.17712 },
    ],
    symbol: 'Cn',
    name: 'Copernicium',
    mass: null,
  },
  {
    number: 113,
    isotopes: [
      { nominal: 278, mass: 278.17058 },
      { nominal: 279, mass: 279.17095 },
      { nominal: 280, mass: 280.17293 },
      { nominal: 281, mass: 281.17348 },
      { nominal: 282, mass: 282.17567 },
      { nominal: 283, mass: 283.17657 },
      { nominal: 284, mass: 284.17873 },
      { nominal: 285, mass: 285.17973 },
      { nominal: 286, mass: 286.18221 },
      { nominal: 287, mass: 287.18339 },
    ],
    symbol: 'Nh',
    name: 'Nihonium',
    mass: null,
  },
  {
    number: 114,
    isotopes: [
      { nominal: 285, mass: 285.18364 },
      { nominal: 286, mass: 286.18423 },
      { nominal: 287, mass: 287.18678 },
      { nominal: 288, mass: 288.18757 },
      { nominal: 289, mass: 289.19042 },
    ],
    symbol: 'Fl',
    name: 'Flerovium',
    mass: null,
  },
  {
    number: 115,
    isotopes: [
      { nominal: 287, mass: 287.1907 },
      { nominal: 288, mass: 288.19274 },
      { nominal: 289, mass: 289.19363 },
      { nominal: 290, mass: 290.19598 },
      { nominal: 291, mass: 291.19707 },
    ],
    symbol: 'Mc',
    name: 'Moscovium',
    mass: null,
  },
  {
    number: 116,
    isotopes: [
      { nominal: 289, mass: 289.19816 },
      { nominal: 290, mass: 290.19864 },
      { nominal: 291, mass: 291.20108 },
      { nominal: 292, mass: 292.20174 },
      { nominal: 293, mass: 293.20449 },
    ],
    symbol: 'Lv',
    name: 'Livermorium',
    mass: null,
  },
  {
    number: 117,
    isotopes: [
      { nominal: 291, mass: 291.20553 },
      { nominal: 292, mass: 292.20746 },
      { nominal: 293, mass: 293.20824 },
      { nominal: 294, mass: 294.21046 },
    ],
    symbol: 'Ts',
    name: 'Teennessine',
    mass: null,
  },
  {
    number: 118,
    isotopes: [
      { nominal: 293, mass: 293.21356 },
      { nominal: 294, mass: 294.21392 },
      { nominal: 295, mass: 295.21624 },
    ],
    symbol: 'Og',
    name: 'Oganesson',
    mass: null,
  },
];
